 

import React, {
  useCallback,
  useRef,
  useState,
  useEffect,
  useReducer,
} from "react";

import OperationUser from "./DesignPrograms/OperationUser";
import Alarming from "./DesignPrograms/Alarming";
import OptimizationEngine from "./DesignPrograms/OptimizationEngine";
import SiteAddUser from "../components/component/SiteAddUser";
import SelectTemplate from "../components/component/SelectTemplate";
import OnGridOptimization from "./DesignPrograms/OnGridOptimization";
import OffGridManagement from "./DesignPrograms/OffGridManagement";
import DisabledUseCase from "./DesignPrograms/DisabledUseCase";

import userScope from "./CustomHooks/userScope";
import useMountEffect from "./CustomHooks/useMountEffect";
import Snackbar from "./SE-Component/Snackbar";
import AlertIcon from "./SE-Component/AlertIcon";
import { DesignProgramProvider } from "./CustomHooks/ContextApi";

import embLabels from "../config/emb-labels-en.json";

import _ from "lodash";

import DcAlertLabels from "../config/DEMAND_CHARGE_ALERT_LIST.json";

//reducers
import {
  initialSystemState,
  systemReducer,
} from "./DesignAssets/Reducers/SystemPageReducer";

//*api call
import ApiSession from "../api/ApiSession";
import ProgressBarContainer from "../components/progressBar/progressBarContainer";
import { upDateProjectType } from "../redux/features/projectTypeSlice";
import { useDispatch, useSelector } from "react-redux";
import { getTooltipData } from "../redux/features/getTooltipDataSlice";
import { useAtom } from "jotai";
import { projectAtomList } from "../atoms";
import useProjectTypeValue from "../utils/useCurrentProjectValue";
import DevicePriority from "../components/DevicePriority";
import {
  initialTypes,
  projectKindReducer,
} from "./DesignAssets/Reducers/projectKindReducer";
import { getProject, getProjectTypeValue } from "../utils/project";
const apiSession = new ApiSession();

const DesignProgramHook = (props) => {
  const UserScope = userScope();
  const dispatch = useDispatch();
  const projectType = getProject();
  const [loading, setLoading] = useState(true);
  const [projectKind, projectKindDispatch] = useReducer(
    projectKindReducer,
    initialTypes
  );
  const [pvCurtailmentExport, setPvCurtailmentExport] = useState(false);
  const [pvCurtailment, setPvCurtailment] = useState(true);
  const [lossOfComm, setlossOfComm] = useState(false);
  const [lossOfCommEMA, setLossOfCommEMA] = useState(false);
  const [utilityLSIEnable, setUtilityLSIEnable] = useState(true);
  const [gensetLSIEnable, setGensetLSIEnable] = useState(true);
  const [loadsDisplay, setLoadsDisplay] = useState(false);
  const [pvBreakers, setPvBreakers] = useState(true);
  const [exportManagement, setExportManagement] = useState(true);
  const [, setBessHibernatingActivated] = useState(false);
  const [siteCreated, setSiteCreated] = useState(false);
  const [templateSelected, setTemplateSelected] = useState(false);
  // const [projectStatusData, setProjectStatusData] = useState();
  const [demandChargeOutput, setDemandChargeOutput] = useState(null);

  const [siteType, setSiteType] = useState("");
  const [clientType, setClientType] = useState("");
  const [architectureType, setArchitectureType] = useState("");
  const [siteGroup, setsiteGroup] = useState(sessionStorage.getItem("pname"));
  const [selectedAlaram, setSelectedAlaram] = useState("NO_ALARM");
  const [selectedAlaram2, setSelectedAlaram2] = useState("");
  const [amsService, setAmsService] = useState({
    sendAlarmsToAMS: false,
  })
  const [BESSChargingEnabled, setBESSChargingEnabled] = useState("Y");
  const [BESSHibernateEnabled, setBESSHibernateEnabled] = useState("N");
  const [values, setValues] = useState("");
  const [, setUpdate] = useState("");
  const [newTemplateName, setNewTemplateName] = useState("");
  const [maxExportPower, setMaxExportPower] = useState(0);
  const [importStartHysteresis, setImportStartHysteresis] = useState(0);
  const [importStopHysteresis, setImportStopHysteresis] = useState(0);
   const [maxLimitEnergyExportPower, setMaxLimitEnergyExportPower] = useState(0);
    const [maxLimitEnergyImportPower, setMaxLimitEnergyImportPower] = useState(0);
  const apiMaxLimitEnergyImportPower = useRef(0);
  const apiMaxLimitEnergyExportPower = useRef(0);
  const [limitImportExport, setLimitImportExport] = useState({
    maxLimitEnergyExportPower: 0,
    minLimitEnergyExportPower: 0,
    maxLimitEnergyImportPower: 0,
    minLimitEnergyImportPower: 0,
    bessImport: false,
    bessExport: false,
    pvExport: false,
    importType:"Limited Import",
    exportType:"Unrestricted Export",
  });
  const [peakImportHysteresis, setPeakImportHysteresis] = useState({
    startHysteresisPercent: 95,
    startHysteresisKw: 0,
    stopHysteresisPercent: 90,
    stopHysteresisKw: 0,
  });

  const [gensetLoad, setGensetLoad] = useState(0);
  const [maxGensetLoad, setMaxGensetLoad] = useState(0);
  const [powerReservePercentageBESS, setPowerReservePercentageBESS] =
    useState(0);
  const [powerReservePercentageGenset, setPowerReservePercentageGenset] =
    useState(20);
  const [, setProgramId] = useState(0);

  const [siteUsers, setSiteUsers] = useState([]);
  const [emailUsers, setEmailUsers] = useState([]);
  const [loads, setLoads] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [domain] = useState([0, 100]);
  const [refresh, setRefresh] = React.useState(0);
  const [outerResetTrigger, setOuterResetTrigger] = useState(0);
  const [currency, setCurrency] = useState("USD");
  const [maxEmaUsers, setMaxEmaUsers] = useState(0);
  const [demandChargeUseCaseSelection, setDemandChargeUseCaseSelection] =
    useState("");
  const [demandChargeData, setDemandChargeData] = useState({
    demandChargeUseCaseSelection: null,
    periodsList: [],
    tariffDef: [],
    demandChargeMaxPower: {
      yearEnabled: false,
      yearPeakCost: null,
    },
    demandChargeYearly: {
      ratchetYearlyPercentage: null,
    },
    dcUsedPower: null,
    dcAverageDuration: null,
    penaltyCalculationFormula: null,
    penaltyCoefficient: null,
  });
  const [defaultTariffData, setDefaultTariffData] = useState({
    demandChargeUseCaseSelection: "TOU",
    penaltyCalculationFormula: null,
    periodsList: [
      {
        periodId: 703,
        periodName: "Period A",
        periodStartDate: "0000-01-01",
        periodEndDate: "0000-12-31",
        weekDay: [
          {
            name: "Monday",
            dayGroup: 550,
          },
          {
            name: "Tuesday",
            dayGroup: 550,
          },
          {
            name: "Wednesday",
            dayGroup: 550,
          },
          {
            name: "Thursday",
            dayGroup: 550,
          },
          {
            name: "Friday",
            dayGroup: 550,
          },
          {
            name: "Saturday",
            dayGroup: 550,
          },
          {
            name: "Sunday",
            dayGroup: 550,
          },
        ],
        dayGroup: [
          {
            dayGroupId: 550,
            dayGroupName: "Day Group 1",
            tariffList: [
              {
                defId: 6,
                name: "OnPeak",
                tariffDefId: 6,
                timeSlot: [],
              },
            ],
            specialDayStatus: false,
            specialDays: [],
          },
        ],
      },
    ],
    tariffDef: [
      {
        defId: 4,
        name: "OnPeak",
      },
      {
        defId: 5,
        name: "midPeak",
      },
      {
        defId: 6,
        name: "OffPeak",
      },
    ],
    demandChargeMaxPower: {
      yearEnable: false,
      yearPeakCost: "",
    },
    penaltyCoefficient: null,
    dcUsedPower: "",
    dcAverageDuration: "",
    demandChargeYearly: {
      ratchetYearlyPercentage: "",
    },
  });
  const [defaultDynamicTariff, setDefaultDynamicTariff] = useState(null);
  const [tariffDynamicConfiguration, setTariffDynamicConfiguration] = useState({
    tariffType: null,
    dynamicHourTariff: {
      platformDayAhead: "",
      platformType: "",
      resolution:""
    },
    spotPriceTariff: {
      platformSpotPrice: "",
      scale: 1000,
      region: "",
    },
  });
  const [sellTariff, setSellTariff] = useState("at0");
  const [deltaSellTariff, setDeltaSellTariff] = useState(0);

  const [optimizationServer, setOptimizationServer] = useState({
    optimizationType: "",
  });

  const [autogridOptimization, setAutogridOptimization] = useState({});

  const [defaultsMinMax, setDefaultsMinMax] = useState({});
  const [gridDetails, setGridDetails] = useState({
    gridOutrageDetection: 2,
    gridOutrageDetectionCase: "",
    gridDetectionTimer: 5000,
    lostDetectionTimer: 500,
  });
  const [isMotorizedOrContactor, setIsMotorizedOrContactor] = useState({
    isPvCBsMotorizedOrContactor: true,
    isBessCBsMotorizedOrContactor: true,
  });
  const [gridSettings, setGridSettings] = useState({
    demandCharge: false,
    tariffManagement: false,
    selfConsumption: false,
    exportOptimization: false,
    noExport: false,
    remoteMonitoringControl: false,
    bessEnergyExchanges: false,
    mode: "FUEL_SAVER",
    gensetBattery: "OPEN",
    gridTransitionOnline: "OPEN",
    gridTransitionOutage: "OPEN",
    manualSwitch: "OPEN",
    isIslandable: false,
    stormPreparedness: false,
    spanishCodeRealTime: false,
    specificMonitoring:false
  });
  const [isEVSelected, setIsEVSelected] = useState(false);
  const [isTMHSelected, setIsTMHSelected] = useState(false);
  const [eVceData, setEvceData] = useState({
    isElectricalVehicleEnergyManagement: false,
    webServiceURL: "",
    noOfZones: "1",
    componentIds: "EVCE1",
    onPeakPowerLimit: "",
    midPeakPowerLimit: "",
    offPeakPowerLimit: "",
    highTariffCurtailment: "",
    ipAddress: "",
    evMaxAllowedPowerDM:"",
  });
  const [evMaxAllowedPower, setEvMaxAllowedPower] = useState();
  const [configuredStatus, setConfiguredStatus] = useState({
    dcConfiguredStatus: 0,
    dynamicConfiguredStatus: 0,
    bessOperatingModes: 0,
    realTimeControlEMA: 0,
    sellTariffConfiguration: 1,
    sellTariffConfiguredStatus: 0,
    scConfiguredStatus: 0,
    emConfiguredStatus: 0,
    lsConfiguredStatus: 0,
    tmConfiguredStatus: 0,
    gofpConfiguredStatus: 0,
    bclConfiguredStatus: 0,
    bhConfiguredStatus: 0,
    configuredBlocks: 0,
    autogridConfiguredStatus: 0,
    exportManagementStatus:1,
    dcThresholdStatus:0,
    bessOperatingModeStatus:1,
    importManagementStatus:1,
    exportManagementStatus1:1,
  });
  const [gensetDetails, setGensetDetails] = useState({
    gensetAvailabilityStatus: false,
    gensetBackfeedProtection: true,
    gensetBackfeedProtectionStatus: "Y",
  });
  const [genset, setGenset] = useState({
    powerReserve: 0,
    max_power: 0,
    changed: "0",
  });
  const [BESS, setBESS] = useState({
    cycle_limit: "100",
    soc_essential: "45",
    powerReserve: 0,
    cycle_period: "7",
    soc_emergency: "55",
    soc_hysteresis: "15",
    soc_max: "90",
    soc_min: "10",
    soc_nominal_power: "60",
    SoC_min_optimization: "40",
    changed: "0",
  });
  const [batteryDetails, setBatteryDetails] = useState({
    batteryBuffering: true,
    batteryBufferingExport: true,
    batteryBufferingStatus: false,
  });
  const [loadShedding, setLoadShedding] = useState({

    loadShedding: false,
    loadSheddingActivatedGridTied: false,
    loadSheddingStatus: "N",
    loadSheddingGridtiedStatus: "N",
  });
  const [loadList, setLoadList] = useState({
    emergencyList: [],
    essentialList: [],
    nonEssentialList: [],
    gridTiedAllowIslandingList: [],
    gridTiedNotAllowIslandingList: [],
  });
  const [gridTiedLoadsSheddable, setGridTiedLoadsSheddable] = useState("0");
  const [dndDetails, setDndDetails] = useState({
    draggedLoad: {},
    draggedLoadFrom: "",
  });
  const [reconnectionTimers, setReconnectionTimers] = useState({
    reconnectionTimer: 0,
    reconnection2Timer: 0,
  });
  const [BESSCharging, setBESSCharging] = useState({
    BESS_charging_limitation_enabled: true,
    BESS_PV_limitation_enable: true,
    BESS_PV_disconnection: true,
  });
  const [additionalUserAlert, setAdditionalUserAlert] = useState(false);
  const [popupStatus, setPopupStatus] = useState({
    addUserPopUpStatus: false,
    deleteSiteUserConfirmPopUpStatus: false,
    inviteUserToAlaramStatus: false,
    deleteUserFromAlarmStatus: false,
    loadSheddingConfirmTruePopUpStatus: false,
    loadSheddingConfirmPopUpStatus: false,
    gensetOptimisationConfirmPopUpStatus: false,
    bessChargingConfirmPopUpStatus: false,
    besshibernateConfirmPopUpStatus: false,
    utilityPvOpeningConfirmpopUpSattus: false,
    gensetPvOpeningConfirmpopUpSattus: false,
    templatePopUpStatus: false,
    newTemplateConfirmPopUpStatus: false,
    loadSheddingIslandConfirmTruePopUpStatus: false,
    loadSheddingIslandConfirmPopUpStatus: false,
  });
  const [popupInfo, setPopupInfo] = useState({
    deleteSiteUserId: "",
    deleteEmailId: "",
  });
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [alert, setAlert] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "",
    isRoute: false,
    routePath: "",
  });
  const [runEffects, setRunEffects] = useState({
    loadPriority: false,
  });
  const [gxsExternalIDs, setGsxExternalIds] = useState([]);
  const [isPortableGenset, setIsPortableGenset] = useState(false);
  const [limitExport, setLimitExport] = useState(false);
  const [limitImport, setLimitImport] = useState(false);
  const [derPriority, setDerPriority] = useState(null);
  const [isPortableGensetSelection, setIsPortableGensetSelection] =
    useState("");
  const [isBessOperatingMode, setIsBessOperatingMode] = useState("UNRESTRICTED");
  const [emaRoles, setEmaRoles] = useState({});
  const [currentProject, setCurrentProject] = useAtom(projectAtomList);
  const { projectId } = (props?.match.params ?? {});
  const projectTypeValue = useProjectTypeValue();
  let projectTypeData = getProjectTypeValue();
  const projectStatusData = currentProject?.projectStatus;
  const [billingPeriod, setBillingPeriod] = useState({
    billingType: "FIRST",
    fixDay: 1,
    customDays: null,
  });
  const [dcthresholdCustomMonthErrors, setDcthresholdCustomMonthErrors] = useState({});
  const generateDefaultData = () => {
    const months = Array.from({ length: 12 }, (_, i) => {
      const month = (i + 1).toString().padStart(2, "0");
      return {
        date: `0000-${month}-01`,
        billingPeriodPreset: "",
        peakPreset: "",
      };
    });
    return months;
  };
  const [dcthreshold, setDcthreshold] = useState({
    type: "FIXED",
    valueType: "VALUE",
    fixedValues: { peakPreset: '', billingPeriodPreset: '', },
    customValues: generateDefaultData(),
  });

  // usereducer
  const [systemState, systemDispatch] = useReducer(
    systemReducer,
    initialSystemState
  );
  const [derMaxPowerMap, setDerMaxPowerMap] = useState({
    "Utility": "",
    "EV_charging_station": "",
    "BESS": ""
})
  useEffect(() => {
    if (projectStatusData?.projectName) {
      setsiteGroup(projectStatusData?.projectName);
    }
  }, [projectStatusData]);

  const snackBarRef = useRef(null);
  const updateUtilityDates = (dates) => {
    setBillingPeriod(prev => {
      return {
        ...prev,
        customDays: dates
      }
    })
  }
  const getExternalID = async (data) => {
    try {
      const response = await apiSession.getProjectExternalId();
      if (response) {
        setGsxExternalIds(response);
        data.resources = data.resources.map((item, idx) => {
          item.id = response[idx + 6];
          return item;
        });
        data.servicePoint = response[10];
        setAutogridOptimization(data);
      }
    } catch (error) {
      if (error.response !== undefined) {
        if (error.response) {
          callSnackbar("error", `${error?.message}`);
        }
      }
    }
  };
  const getEmaUserRoles = async () => {
    try {
      const response = await apiSession.getEmaRoles(projectId);
      if (response) {
        setEmaRoles(response);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const openAutoGridFlex = async () => {
    if (
      document.querySelectorAll("[data-test-id=tariff-data]")[0]?.parentElement
        ?.parentElement?.parentNode?.classList?.[0] === "accordionClose"
    ) {
      await new Promise((resolve) => {
        document
          .querySelectorAll("[data-test-id=tariff-data]")[0]
          .addEventListener("click", resolve, { once: true });
        document.querySelectorAll("[data-test-id=tariff-data]")[0]?.click();
      });
    }
  };

  useEffect(() => {
    getEmaUserRoles();
    dispatch(getTooltipData(null));
  }, []);
  useMountEffect(() => {
    sessionStorage.setItem("programDataModified", false);
    sessionStorage.setItem("toBeSavedAsDraft", false);

    if (gridDetails?.gridOutrageDetection === 2) {
      setGridDetails((prevState) => ({
        ...prevState,
        gridOutrageDetectionCase: "HWS",
      }));
    } else {
      setGridDetails((prevState) => ({
        ...prevState,
        gridOutrageDetectionCase: "CB",
      }));
    }
    if (!projectId) {
      setLoading(false);
      let { history } = props;
      history?.push({
        pathname: `${"/information"}/${projectId}`,
      });
    } else {
      let demandChargeDataNew = { ...demandChargeData };
      setDemandChargeData(demandChargeDataNew);
      setDemandChargeUseCaseSelection(
        demandChargeDataNew?.demandChargeUseCaseSelection
      );

      setTimeout(() => getProgramData(projectId), 2000);
    }
  }, []);

  useEffect(() => {
    return () => {
      if (sessionStorage.getItem("toBeSavedAsDraft") === "true") {
        saveDraftGenerateProgram(false);
      }
    };
  },[]);

  useMountEffect(() => {
    if (runEffects.loadPriority) {
      updateLoadsPriority();
    }
  }, [runEffects]);
  useEffect(() => {
    if(BESSCharging.BESS_PV_limitation_enable === false && BESSCharging.BESS_PV_disconnection === false){
      setBESSChargingEnabled("N");
    }
   
  }, [BESSCharging]);
  useEffect(() => {
    const seApp = document.getElementsByClassName("se-app-body");
    const seContainer = document.getElementsByTagName("se-container");

    if (seApp.length && seContainer.length) {
      seContainer[0].removeAttribute("position");
      seApp[0].style.position = "absolute";
    }

    return () => {
      if (seApp.length && seContainer.length) {
        seApp[0].style.position = "absolute";
        seContainer[0].setAttribute("position", "absolute");
      }
    };
  }, [siteType]);
  // useEffect(()=>{
  //   openAutoGridFlex();
  // },[loading])
  const applyProgramResponse = (response) => {
          apiMaxLimitEnergyImportPower.current = response?.maxLimitEnergyImportPower ?? 0;
          apiMaxLimitEnergyExportPower.current = response?.maxLimitEnergyExportPower ?? 0;
          sessionStorage.setItem("programPage", response?.programPage);
          if (response?.derMaxPowerMap) {
            setDerMaxPowerMap(JSON.parse(response?.derMaxPowerMap));
          }
          if (response?.dcThreshold) {
            setDcthreshold(JSON.parse(response?.dcThreshold));
          }
          if (response?.billingPeriod) {
            setBillingPeriod(JSON.parse(response?.billingPeriod))
          }
          if (response?.additionalUsersQty) {
            setMaxEmaUsers(response?.additionalUsersQty);
          }
          if (response?.gridTiedLoadsSheddable) {
            setGridTiedLoadsSheddable(
              JSON.stringify(response?.gridTiedLoadsSheddable)
            );
          }
          const defaultsData = {};
          for (let data of (response?.defaultValues ?? [])) {
            defaultsData[data["param"]] = data.value;
          }
          if (response?.meteringPriority) {
            setDerPriority(response?.meteringPriority);
          }
           setIsTMHSelected(response?.tmhEVCE === true ? true : false);
          if (response?.electricalVehicleEnergyMgmtJson !== null) {
            const eVceDataJson = JSON.parse(
              response?.electricalVehicleEnergyMgmtJson
            );

            setEvceData((prevData) => {

              return {
                ...prevData,
                ...eVceDataJson,
              };
            });
            setIsEVSelected(eVceDataJson.electricalVehicleEnergyManagement);
           
          }
        
          if (
            response?.gridSettings?.exportOptimization &&
            (response?.peakStartImportHysteresis === 0 ||
              response?.peakStartImportHysteresis) &&
            (response?.peakStopImportHysteresis === 0 ||
              response?.peakStopImportHysteresis) &&
            response?.peakStartImportHysteresis !== null &&
            response?.peakStopImportHysteresis !== null
          ) {
            setPeakImportHysteresis((prev) => {
              const startKw =
                response?.peakStartImportHysteresis &&
                (Number(response?.maxLimitEnergyImportPower) *
                  Number(response?.peakStartImportHysteresis)) /
                100;
              const stopKw =
                response?.peakStopImportHysteresis &&
                (Number(response?.maxLimitEnergyImportPower) *
                  Number(response?.peakStopImportHysteresis)) /
                100;
              return {
                startHysteresisPercent: response?.peakStartImportHysteresis,
                startHysteresisKw: startKw,
                stopHysteresisPercent: response?.peakStopImportHysteresis,
                stopHysteresisKw: stopKw,
              };
            });
          } else {
            if (response?.gridSettings?.exportOptimization === false) {
              setPeakImportHysteresis((prev) => {
                const startKw =
                  defaultsData?.PeakStartImportHysteresis &&
                  (Number(response?.maxLimitEnergyImportPower) *
                    Number(defaultsData?.PeakStartImportHysteresis)) /
                  100;
                const stopKw =
                  defaultsData?.peakStopImportHysteresis &&
                  (Number(response?.maxLimitEnergyImportPower) *
                    Number(defaultsData?.peakStopImportHysteresis)) /
                  100;
                return {
                  startHysteresisPercent:
                    defaultsData?.PeakStartImportHysteresis,
                  startHysteresisKw: startKw,
                  stopHysteresisPercent: defaultsData?.peakStopImportHysteresis,
                  stopHysteresisKw: stopKw,
                };
              });
            }
          }

          setCurrency(response?.currency ?? "USD");
          setDefaultsMinMax(defaultsData);
          setSiteCreated(response?.siteCreated);
          setLossOfCommEMA(response?.lossOfCommEMA);
          setIsPortableGensetSelection(response?.portableGensetMethod);
          setIsPortableGenset(response?.portableGenset);
          setDefaultDynamicTariff(response?.defaultDynamicTariffData);

          setIsBessOperatingMode(response?.bessOperatingModes);

          if ((projectKind?.projectTypeValue === "NMGaaS ETO" || projectTypeValue === "NMGaaS ETO" || projectTypeData === "NMGaaS ETO") && response?.gridSettings?.bessOperatingModeType === "unrestricted") {
            setIsBessOperatingMode("UNRESTRICTED");
          }
          if ((projectKind?.projectTypeValue === "NMGaaS ETO" || projectTypeValue === "NMGaaS ETO" || projectTypeData === "NMGaaS ETO") && response?.gridSettings?.bessOperatingModeType !== "unrestricted") {
            response?.bessOperatingModes === "EXPORT_ONLY" && !["UNRESTRICTED", "EXPORT_ONLY", "IMPORT_ONLY", "NO_EXCHANGE"].includes(response?.bessOperatingModes) ? setIsBessOperatingMode("EXPORT_ONLY") : response?.bessOperatingModes;
          }

          if (
            response?.siteType === embLabels.PV_HYBRIDIZATION ||
            response?.siteType === embLabels.ISLANDABLE_GSX
          ) {
            setGensetLSIEnable(false);
            setUtilityLSIEnable(false);
          }

          if (response?.programId) {
            setGridDetails((prevState) => ({
              ...prevState,
              gridOutrageDetectionCase:
                response?.gridOutrageDetection === 1 ? "CB" : "HWS",
              gridDetectionTimer: parseInt(response?.gridDetectionTimer),
              lostDetectionTimer: parseInt(response?.lostDetectionTimer),
              gridOutrageDetection: response?.gridOutrageDetection,
            }));
            setPvCurtailment(response?.pvCurtailment);
            setPvBreakers(response?.pvBreakers);
            setsiteGroup(response?.siteGroup);

            setBatteryDetails((prevState) => ({
              ...prevState,
              batteryBuffering: response?.batteryBuffering,
              batteryBufferingExport: response?.batteryBufferingExport,
            }));
            setReconnectionTimers((prevState) => ({
              ...prevState,
              reconnectionTimer: response?.reconnectionTimer,
              reconnection2Timer: response?.reconnection2Timer,
            }));

            setExportManagement(response?.exportManagement);

            const loadShedding =
              (response?.siteType === embLabels.GRID_CONNECTED_GSX &&
                (projectTypeValue === "DaaS ANSI" ||
                  projectTypeValue === "DaaS ETO"))
                // ? false
                // :response?.siteType === "OFF_GRID"
                ? false
                : response.loadShedding;
            const loadSheddingActivatedGridTied =
              (response.siteType === embLabels.GRID_CONNECTED_GSX &&
                (projectTypeValue === "DaaS ANSI" ||
                  projectTypeValue === "DaaS ETO"))
                ? false
                :response?.siteType === "OFF_GRID"
                ? false
                : response?.gridSettings?.exportOptimization? response.loadSheddingActivatedGridTied : false;
            setLoadShedding((prevState) => ({
              ...prevState,
              loadShedding: loadShedding,
              loadSheddingActivatedGridTied: loadSheddingActivatedGridTied ?? false,
              loadSheddingStatus: response?.loadShedding === true ? "Y" : "N",
              loadSheddingGridtiedStatus: (response?.gridSettings?.exportOptimization && response?.loadSheddingActivatedGridTied === true) ? "Y" : "N",
             }));
             if(response?.gridSettings?.exportOptimization === false && response?.siteType === embLabels.GRID_CONNECTED){
               setPeakImportHysteresis({
                 startHysteresisPercent: 95,
                 startHysteresisKw: 0,
                 stopHysteresisPercent: 90,
                 stopHysteresisKw: 0,
               });
              setMaxLimitEnergyImportPower(0);
              setMaxLimitEnergyExportPower(0);
              setLoadShedding((prevState) => ({
              loadShedding: false,
              loadSheddingActivatedGridTied :false,
              loadSheddingStatus:  "N",
              loadSheddingGridtiedStatus:  "N",
              }));
             }
            setGensetLSIEnable(response?.gensetLSIEnable);
            setUtilityLSIEnable(response?.utilityLSIEnable);
            setGensetLoad(response?.gensetLoad);
            setPvCurtailmentExport(response?.pvCurtailmentExport);
            setlossOfComm(response?.lossOfComm);
            setMaxExportPower(response?.maxExportPower);

            setImportStartHysteresis(response?.importStartHysteresis);
            setImportStopHysteresis(response?.importStopHysteresis);
             setMaxLimitEnergyExportPower(response?.maxExportPower);
            setMaxLimitEnergyImportPower(response?.maxLimitEnergyImportPower);
            setLimitExport(response?.limitExport ?? false);
            setLimitImport(response?.limitImport ?? false);
             setMaxLimitEnergyExportPower(response?.maxLimitEnergyExportPower??0);
            setMaxLimitEnergyImportPower(response?.maxLimitEnergyImportPower??0);
            setLimitImportExport(prevState => {
              return {
                ...prevState,
                maxLimitEnergyExportPower: response?.maxLimitEnergyExportPower ?? 0,
                maxLimitEnergyImportPower: response?.maxLimitEnergyImportPower ?? 0,
                bessImport: response?.bessImport ?? false,
                bessExport: response?.bessExport ?? false,
                pvExport: response?.pvExport ?? false,
                importType: response?.importType ?? "Limited Import",
                exportType: response?.exportType === "Limited Export" ? "Custom Export" :    response?.exportType,
              }
            })
            setSelectedAlaram(
              response?.alarm === null ? "NO_ALARM" : response?.alarm?.alarmType
            );
            setAmsService(prev => {
              return {
                sendAlarmsToAMS: response?.alarm?.amsService?.sendAlarmsToAMS,
              }
            })
            setProgramId(response.programId);
            setBessHibernatingActivated(response.bessHibernatingActivated);
            configuredAll();
          } else {
            setPvBreakers(true);
            setConfiguredStatus((prevState) => ({
              ...prevState,
              configuredBlocks: 0,
            }));

            setPvCurtailment(true);
            // setsiteGroup(projectStatusData?.projectName);
            setGridDetails((prevState) => ({
              ...prevState,
              gridOutrageDetection: response?.gridOutrageDetection,
              gridOutrageDetectionCase:
                response?.gridOutrageDetection === 1 ? "CB" : "HWS",
              gridDetectionTimer: parseInt(response?.gridDetectionTimer),
              lostDetectionTimer: parseInt(response?.lostDetectionTimer),
            }));

            setBatteryDetails((prevState) => ({
              ...prevState,
              batteryBuffering:
                response?.siteType === embLabels.GENSET_PVBESS_A2E,
              batteryBufferingExport: response?.batteryBufferingExport ?? false,
            }));
            setReconnectionTimers((prevState) => ({
              ...prevState,
              reconnectionTimer: response?.reconnectionTimer,
              reconnection2Timer: response?.reconnection2Timer,
            }));
            setlossOfComm(response?.lossOfComm ?? false);
            if (
              response.siteType === embLabels.GENSET_PVBESS_A2E ||
              (response.siteType === embLabels.GRID_CONNECTED_GSX &&
                (projectTypeValue === "DaaS ANSI" || projectTypeData === "DaaS ANSI" ||
                  projectTypeValue === "DaaS ETO" || projectTypeData === "DaaS ETO")) ||
              (response.siteType === embLabels.GRID_CONNECTED &&
                projectTypeValue === "MGaaS ANSI" || projectTypeData === "MGaaS ANSI") ||
              (response.siteType === embLabels.GRID_CONNECTED &&
                (projectTypeValue === "MGaaS IEC" || projectTypeData === "MGaaS IEC" ||
                  projectTypeValue === "MGaaS ETO" || projectTypeData === "MGaaS ETO"))||
                  response.siteType === embLabels.OFF_GRID
            ) {
              const loadShedding =
                (response.siteType === embLabels.GRID_CONNECTED_GSX &&
                  (projectTypeValue === "DaaS ANSI" || projectTypeData === "DaaS ANSI" ||
                    projectTypeValue === "DaaS ETO" || projectTypeData === "DaaS ETO")) ||
                  (response.siteType === embLabels.ISLANDABLE && (projectTypeValue === "MGaaS ANSI" || projectTypeData === "MGaaS ANSI"))
                 ? false
                  // :response?.siteType === "OFF_GRID"
                  // ? false
                  : response.loadShedding;
              const loadSheddingActivatedGridTied =
                (response.siteType === embLabels.GRID_CONNECTED_GSX &&
                  (projectTypeValue === "DaaS ANSI" || projectTypeData === "DaaS ANSI" ||
                    projectTypeValue === "DaaS ETO" || projectTypeData === "DaaS ETO"))
                  ? false
                  :response?.siteType === "OFF_GRID"
                  ? false
                  : response.loadSheddingActivatedGridTied;
              setLoadShedding((prevState) => ({
                ...prevState,
                loadShedding: loadShedding,
                loadSheddingActivatedGridTied: loadSheddingActivatedGridTied ?? false,
                loadSheddingStatus: loadShedding === true ? "Y" : "N",
                loadSheddingGridtiedStatus: response?.loadSheddingActivatedGridTied === true ? "Y" : "N",

              }));
            }
            
         
            // Reset must also restore limit import/export defaults for non-configured programs.
            setImportStartHysteresis(response?.importStartHysteresis ?? 0);
            setImportStopHysteresis(response?.importStopHysteresis ?? 0);
            setLimitExport(response?.limitExport ?? false);
            setLimitImport(response?.limitImport ?? false);
            setLimitImportExport((prevState) => {
              return {
                ...prevState,
                maxLimitEnergyExportPower: response?.maxLimitEnergyExportPower ?? 0,
                maxLimitEnergyImportPower: response?.maxLimitEnergyImportPower ?? 0,
                bessImport: response?.bessImport ?? false,
                bessExport: response?.bessExport ?? false,
                pvExport: response?.pvExport ?? false,
                 importType: response?.importType ?? "Limited Import",
                exportType: response?.exportType === "Limited Export" ? "Custom Export" :    response?.exportType,
              };
            });

            // Reset alarm use-case selection for non-configured programs too.
            setSelectedAlaram(
              response?.alarm === null ? "NO_ALARM" : response?.alarm?.alarmType
            );
            setAmsService((prev) => {
              return {
                sendAlarmsToAMS: response?.alarm?.amsService?.sendAlarmsToAMS ?? false,
              };
            });
          }

          if (
            response?.gridSettings?.mode === "FUEL_ERASER" ||
            response?.gridSettings?.mode === "NO_FUEL"
          ) {
            setBESSHibernateEnabled(
              response?.bessHibernatingActivated === true ? "Y" : "N"
            );
          } else {
            setBESSHibernateEnabled("N");
            setBessHibernatingActivated(false);
          }

          //* DC
          if (response?.demandCharge !== null) {
            let parsedDemandCharge = {};
            try {
              parsedDemandCharge = JSON.parse(response?.demandCharge || "{}");
            } catch (error) {
              parsedDemandCharge = {};
            }

            const demandChargeNew = {
              ...parsedDemandCharge,
              currency: sessionStorage.getItem("currency"),
              tariffDef: Array.isArray(parsedDemandCharge?.tariffDef)
                ? parsedDemandCharge.tariffDef
                : [],
              periodsList: Array.isArray(parsedDemandCharge?.periodsList)
                ? parsedDemandCharge.periodsList.map((obj) => {
                    if (!obj?.id) return obj;
                    const { id, ...rest } = obj;
                    return { ...rest, periodId: id };
                  })
                : [],
            };

            setDemandChargeData(demandChargeNew);
            setDemandChargeOutput({ ...demandChargeNew });
            setDemandChargeUseCaseSelection(
              demandChargeNew?.demandChargeUseCaseSelection
            );
          } else {
            let demandChargeNew = Object.assign({}, demandChargeData);
            setDemandChargeOutput(
              response?.gridSettings?.tariffManagement
                ? defaultTariffData
                : demandChargeNew
            );
            configuredStatusNot("dcConfiguredStatus");
          }
          //dynamic tariff
          if (response?.tariffDynamicConfiguration !== null) {
            let tariffData = JSON.parse(response?.tariffDynamicConfiguration || "{}");
            if (tariffData?.tariffType === "dynamic") {
              setTariffDynamicConfiguration((prev) => ({
                tariffType: tariffData?.tariffType,
                dynamicHourTariff: {
                  platformDayAhead:tariffData?.dynamicHourTariff?.platformDayAhead,
                  platformType:tariffData?.dynamicHourTariff?.platformType ?? "omie",
                  resolution:tariffData?.dynamicHourTariff?.resolution ?? "",
                },
              }));
            } else {
              setTariffDynamicConfiguration((prev) => ({
                tariffType: tariffData?.tariffType,
                spotPriceTariff: {
                  platformSpotPrice:
                    tariffData?.spotPriceTariff?.platformSpotPrice,
                  scale: tariffData?.spotPriceTariff?.scale,
                  region: tariffData?.spotPriceTariff?.region,
                },
              }));
            }
          } else {
            setTariffDynamicConfiguration(null);
          }
          setSellTariff(response?.sellTariff ?? "at0");
          setDeltaSellTariff(response?.deltaSellTariff ?? 0);
          //* BESS
          if (response?.BESS?.energyReserveRequired === "true") {
            setCurrentProject((prev) => ({ ...prev, isEnergyReserveSelectd: true }));
          }
          let newBESS = _.cloneDeep(BESS);
          if (response?.BESS) {
            newBESS = response?.BESS;
          }

          //* Optimization

          setAutogridOptimizationDetails(response);

          if (response?.programId) {
            //* do nothing
          } else {
            newBESS.soc_emergency = parseInt(newBESS.soc_emergency);
            newBESS.soc_essential = parseInt(newBESS.soc_essential);
            // newBESS.soc_nominal_power =
            //   parseInt(newBESS.soc_min) + parseInt(newBESS.soc_nominal_power);
          }

          setBESS(newBESS);

          calculateLoadSliderDisplayValues(newBESS);

          if (parseInt(newBESS.powerReserve) === 0) {
            setPowerReservePercentageBESS(20);
            let reservePower = Math.round(
              parseFloat(newBESS.max_power / 100) * parseFloat(20)
            );

            setBESS((prevState) => ({
              ...prevState,
              powerReserve: reservePower >= 0 ? reservePower : 0,
            }));
          } else if (parseInt(newBESS.powerReserve) > 0) {
            let reservePercentageBess = (
              (parseFloat(newBESS.powerReserve) /
                parseFloat(newBESS.max_power)) *
              100
            ).toFixed(2);
            setPowerReservePercentageBESS(
              reservePercentageBess >= 0
                ? Math.round(Number(reservePercentageBess))
                : 0
            );
          }

          setSiteUsers(response.emaSiteUsers);
          setGridSettings(prev =>{
            if(projectTypeValue === "NMGaaS ETO EMOL" || projectTypeData === "NMGaaS ETO EMOL" || response?.siteType === "OFF_GRID"){
               return {
                  ...response.gridSettings,
                  demandCharge: false,
                  tariffManagement: false,
                  selfConsumption: response?.siteType === "OFF_GRID"?false:response?.gridSettings?.selfConsumption,
               }
            }else{
               return response.gridSettings;
            }
          });
          if (response?.gridSettings?.electricalVehicleEnergyManagement) {
            const eveceDataJson = JSON.parse( response?.electricalVehicleEnergyMgmtJson );
            // setIsEVSelected(eveceDataJson.electricalVehicleEnergyManagement);
            setEvMaxAllowedPower(response?.evMaxAllowedPower);
            setEvceData((prev) => {
              return {
                ...prev,
                isElectricalVehicleEnergyManagement:response?.gridSettings?.electricalVehicleEnergyManagement,
                highTariffCurtailment:response?.evMaxAllowedPower === 0 ?"":eveceDataJson?.highTariffCurtailment,
                onPeakPowerLimit:response?.evMaxAllowedPower === 0 ?"":eveceDataJson?.onPeakPowerLimit,
              };
            });
          }
           if(response?.tmhEVCE === true){
               const eveceDataJson = JSON.parse( response?.tmhEvceJson );
               setEvceData((prev) => {
              return {
                noOfZones: eveceDataJson?.noOfZones ?? "1",
                ipAddress: eveceDataJson?.evceIpAddress ?? "",
                evMaxAllowedPowerDM:  (eveceDataJson?.evMaxAllowedPowerDM === "" || eveceDataJson?.evMaxAllowedPowerDM === undefined)?response.evMaxAllowedPower:eveceDataJson?.evMaxAllowedPowerDM,
              };
            });
          }
          setIsMotorizedOrContactor({
            isPvCBsMotorizedOrContactor: response?.isPvCBsMotorizedOrContactor,
            isBessCBsMotorizedOrContactor:
              response?.isBessCBsMotorizedOrContactor,
          });
          if (
            !response?.isPvCBsMotorizedOrContactor ||
            !response?.isBessCBsMotorizedOrContactor
          ) {
            setlossOfComm(false);
            setUtilityLSIEnable(false);
          }
          if (response?.gridSettings?.spanishCodeRealTime) {
            setBatteryDetails((prev) => ({
              ...prev,
              batteryBufferingExport: true,
            }));
            setlossOfComm(true);
            setPvCurtailmentExport(true);
            setUtilityLSIEnable(false);
          }
          setSiteType(response?.siteType);
          setClientType(response?.clientType);
          setArchitectureType(response?.architecture);
          assignLoads(response);
          setCurrentProject(prev => {
            return {
              ...prev,
              resources: response
            }
          });
          getProjectUsecase(projectId, response?.gridSettings);
          setGensetDetails((prevState) => ({
            ...prevState,
            gensetBackfeedProtection: response?.gensetBackfeedProtection,
            gensetBackfeedProtectionStatus:
              response?.gensetBackfeedProtection === true ? "Y" : "N",
          }));
          if (response?.resetLoads === true) {
            loadSheddingdefaultReset(response?.resources);
          }
          //* GENSET
          let newGenset = _.cloneDeep(genset);
          newGenset = response?.Genset ? response?.Genset : newGenset;
          if (response?.Genset) {
            setGenset(newGenset);
          }

          setMaxGensetLoad(newGenset?.max_power);
          if (parseInt(newGenset?.powerReserve) === 0) {
            setPowerReservePercentageGenset(20);
            let reservePower = Math.round(
              parseFloat(newGenset?.max_power / 100) * parseFloat(20)
            );

            setGenset((prevState) => ({
              ...prevState,
              powerReserve: reservePower >= 0 ? reservePower : 0,
            }));
          } else if (parseInt(newGenset?.powerReserve) > 0) {
            let reservePercentage = (
              (parseFloat(newGenset?.powerReserve) /
                parseFloat(newGenset?.max_power)) *
              100
            ).toFixed(2);
            setPowerReservePercentageGenset(
              reservePercentage >= 0 ? Math.round(Number(reservePercentage)) : 0
            );
          }

          if (response?.bessChargingLimitation !== null) {
            let parsingResult = JSON.parse(response?.bessChargingLimitation);
            let BESSChargingNew = Object.assign({}, BESSCharging);
            BESSChargingNew = parsingResult;
            setBESSCharging(BESSChargingNew);
            // setBESSChargingEnabled(
            //   parsingResult.BESS_charging_limitation_enabled === true
            //     ? "Y"
            //     : "N"
            // );
          }

          if (
            response?.gridSettings?.demandCharge ||
            response?.gridSettings?.tariffManagement
          ) {
            getDcTemplates();
          }

          if (response?.programId) {
            if (
              response?.gridSettings?.noExport === false &&
              response?.gridSettings?.exportOptimization === true
            ) {
              setPvCurtailmentExport(false);
              // setUtilityLSIEnable(false);
            }

            if (parseInt(newGenset?.changed) === 0) {
              setGensetLoad(
                Math.round(parseFloat(newGenset?.max_power / 100) * 30)
              );
            } else {
              setGensetLoad(
                Math.round(
                  parseFloat(newGenset.max_power / 100) *
                  parseFloat(response.loadPercentage)
                )
              );
            }
          } else {
            setPvCurtailmentExport(
              response?.pvCurtailmentExport ??
                (response?.gridSettings?.noExport === true)
            );
            setUtilityLSIEnable(
              response?.gridSettings?.spanishCodeRealTime
                ? false
                : response?.utilityLSIEnable ??
                    (response?.gridSettings?.noExport === true)
            );

            const newGensetLoad = Math.round(
              parseFloat(newGenset?.max_power / 100) * 30
            );

            setGensetLoad(newGensetLoad);
            if (
              response?.siteType === embLabels.PV_HYBRIDIZATION ||
              response?.siteType === embLabels.ISLANDABLE_GSX
            ) {
              setGensetLSIEnable(false);
              setUtilityLSIEnable(false);
            }
          }
          if(response.gridSettings.exportOptimization === false){
            setLimitImport(false);
            setLimitExport(false);
            setLimitImportExport( prev =>({
              ...prev,
                maxLimitEnergyExportPower: 0,
                minLimitEnergyExportPower: 0,
                maxLimitEnergyImportPower: 0,
                minLimitEnergyImportPower: 0,
                bessImport: false,
                bessExport: false,
                // pvExport: false,
                            }));
          }
          setLoading(false);
   };

  const getProgramData = (projectId) => {
    setLoading(true);
    try {
      return apiSession
        .getProgramData(projectId)
        .then(applyProgramResponse)
        .catch(() => {
          setPvCurtailment(true);
          setPvBreakers(true);
          setGridDetails((prevState) => ({
            ...prevState,
            gridOutrageDetectionCase: "HWS",
            gridDetectionTimer: defaultsMinMax.goodGridDetectionTimerDefault,
            lostDetectionTimer: defaultsMinMax.gridLostTimerDefault,
            gridOutrageDetection: 2,
          }));
          setGensetDetails((prevState) => ({
            ...prevState,
            gensetBackfeedProtection: false,
            gensetBackfeedProtectionStatus: "N",
          }));
          setsiteGroup(sessionStorage.getItem("pname"));
          setLoading(false);
        });


    } catch (error) {
      console.log(error);
    }
  };

  const getDcTemplates = () => {
    setLoading(true);

    apiSession
      .getTemplate()
      .then((json) => {
        setTemplates(json);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const assignLoads = (response) => {
    let loadsFromAPI = [];
    let loadsEM = [];
    let loadsES = [];
    let loadsNES = [];
    let loadsGAI = [];
    let loadsGANI = [];
    let loadManagementTabStatus = false;

    response?.resources?.forEach((resourcesData) => {
      if (
        parseInt(resourcesData.attributes[0].motorized.attributeValue) === 1
      ) {
        loadManagementTabStatus = true;
      }

      if (
        parseInt(resourcesData.attributes[0].loadCategory.attributeValue) === 0
      ) {
        loadsFromAPI.push(resourcesData);
      } else if (
        parseInt(resourcesData.attributes[0].loadCategory.attributeValue) === 1
      ) {
        loadsEM.push(resourcesData);
      } else if (
        parseInt(resourcesData.attributes[0].loadCategory.attributeValue) === 2
      ) {
        loadsES.push(resourcesData);
      } else if (
        parseInt(resourcesData.attributes[0].loadCategory.attributeValue) === 3
      ) {
        loadsNES.push(resourcesData);
      } else if (
        parseInt(resourcesData.attributes[0].loadCategory.attributeValue) === 5
      ) {
        loadsGAI.push(resourcesData);
      } else if (
        parseInt(resourcesData.attributes[0].loadCategory.attributeValue) === 4
      ) {
        loadsGANI.push(resourcesData);
      }
    });
    setLoadsDisplay(loadManagementTabStatus);

    loadsEM.sort(function (a, b) {
      return (
        a.attributes[0]?.loadPriority?.attributeValue -
        b.attributes[0]?.loadPriority?.attributeValue
      );
    });
    loadsES.sort(function (a, b) {
      return (
        a?.attributes[0]?.loadPriority?.attributeValue -
        b?.attributes[0]?.loadPriority?.attributeValue
      );
    });
    loadsNES.sort(function (a, b) {
      return (
        a?.attributes[0]?.loadPriority?.attributeValue -
        b?.attributes[0]?.loadPriority?.attributeValue
      );
    });
    loadsGAI.sort(function (a, b) {
      return (
        a?.attributes[0]?.loadPriority?.attributeValue -
        b?.attributes[0]?.loadPriority?.attributeValue
      );
    });
    loadsGANI.sort(function (a, b) {
      return (
        a?.attributes[0]?.loadPriority?.attributeValue -
        b?.attributes[0]?.loadPriority?.attributeValue
      );
    });
    setLoads(loadsFromAPI);
    setLoadList((prevState) => {
      return {
        ...prevState,
        emergencyList: loadsEM,
        essentialList: loadsES,
        nonEssentialList: loadsNES,
        gridTiedAllowIslandingList: loadsGAI,
        gridTiedNotAllowIslandingList: loadsGANI,
      };
    });
  };

  const calculateLoadSliderDisplayValues = (newBESS) => {
    if(!newBESS) return;
    let defaultValues = [];
    defaultValues.push(parseInt(newBESS.soc_min));
    if (newBESS?.energyReserveRequired === "true") {
      defaultValues.push(parseInt(newBESS.SoC_min_optimization));
    }

    defaultValues.push(parseInt(newBESS.soc_emergency));
    // defaultValues.push(parseInt(newBESS.soc_nominal_power));
    defaultValues.push(parseInt(newBESS.soc_essential));
    defaultValues.push(parseInt(newBESS.soc_nominal_power));
    defaultValues.push(parseInt(newBESS.soc_max));


    setValues(defaultValues.slice());
    setUpdate(defaultValues.slice());
  };

  const getProjectUsecase = (projectId, gridSettings) => {
    apiSession
      .getselectedUsecase(projectId)
      .then((response) => {
        let bessResult = -1;
        let gensetResult = -1;
        let HybridResult = -1;
        if (response?.length) {
          bessResult = response?.indexOf(embLabels.BESS);
          gensetResult = response?.indexOf(embLabels.GENSET);
          HybridResult = response?.indexOf(embLabels.HYBRID);

          if (gensetResult > -1) {
            setGensetDetails((prevState) => ({
              ...prevState,
              gensetAvailabilityStatus: true,
              gensetBackfeedProtection: true,
            }));
          } else {
            setGensetDetails((prevState) => ({
              ...prevState,
              gensetAvailabilityStatus: false,
              gensetBackfeedProtection: false,
              gensetBackfeedProtectionStatus: "N",
            }));
          }

          if (bessResult > -1 || HybridResult > -1) {
            setBatteryDetails((prevState) => ({
              ...prevState,
              batteryBufferingStatus: true, 
              batteryBuffering: true,
            }));

            if (
              gridSettings?.noExport === true ||
              gridSettings?.exportOptimization === true
            ) {
              setBatteryDetails((prevState) => ({
                ...prevState,
                batteryBufferingExport: true,
              }));
            } else {
              setBatteryDetails((prevState) => ({
                ...prevState,
                // batteryBufferingExport: false,
                batteryBufferingExport: true,
              }));
            }
          } else {
            setBatteryDetails((prevState) => ({
              ...prevState,
              batteryBuffering: false,
              batteryBufferingStatus: false,
              batteryBufferingExport: false,
              // batteryBuffering: true,
              // batteryBufferingStatus: true,
              // batteryBufferingExport: true,
            }));
          }
        } else {
          setBatteryDetails((prevState) => ({
            ...prevState,
            batteryBuffering: false,
            batteryBufferingStatus: false,
            batteryBufferingExport: false,
            // batteryBuffering: true,
            // batteryBufferingStatus: true,
            // batteryBufferingExport: true,
          }));
        }
      })
      .catch(() => {
        //do nothing
      });
  };

  //* Add users to site

  const handleChangeSiteGroup = (e) => {
    setsiteGroup(e.target.value);
    sessionStorage.setItem("programDataModified", true);
  };

  const addUserSite = () => {
    if (siteUsers?.length < maxEmaUsers) {
      setPopupStatus((prevState) => ({
        ...prevState,
        addUserPopUpStatus: true,
      }));
    } else {
      setAdditionalUserAlert(true);
    }
  };

  const closeAddUser = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      addUserPopUpStatus: false,
    }));

  const addUserToSiteList = (data) => {
    const status = siteUsers.findIndex(
      (siteUser) => siteUser.emailId === data.emailAddress
    );
    if (status !== -1) {
      setPopupStatus((prevState) => ({
        ...prevState,
        addUserPopUpStatus: false,
      }));
      callSnackbar(`error`, `User already invited`);
    } else {
      setLoading(true);
      setPopupStatus((prevState) => ({
        ...prevState,
        addUserPopUpStatus: false,
      }));
      apiSession
        .addSiteUser({
          projectId: projectId,
          emailId: data.emailAddress,
          role: data.role,
        })
        .then((response) => {
          setLoading(false);
          callSnackbar("success", response?.status);
          getSiteUsers();
        })
        .catch((error) => {
          setLoading(false);
        
            if (error?.response?.status === 400) {
              callSnackbar("error", error?.response?.data?.message);
            } else if (error?.response?.status === 500) {
              callSnackbar(
                "error",
                "Unable to find user in EMA or EMB, Try later"
              );
            } else {
              callSnackbar("error", "Error in add user to site");
            }
          });
    }
  };

  const getSiteUsers = () => {
    setLoading(true);
    apiSession
      .getProgramData(projectId)
      .then((response) => {
        setSiteUsers(response?.emaSiteUsers);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const removeSiteUserConfirmationPrompt = (siteUserId) => {
    setPopupInfo((prevState) => ({
      ...prevState,
      deleteSiteUserId: siteUserId,
    }));
    setPopupStatus((prevState) => ({
      ...prevState,
      deleteSiteUserConfirmPopUpStatus: true,
    }));
  };

  const closeDeleteSiteUserPopUp = () => {
    setPopupInfo((prevState) => ({ ...prevState, deleteSiteUserId: "" }));

    setPopupStatus((prevState) => ({
      ...prevState,
      deleteSiteUserConfirmPopUpStatus: false,
    }));
  };

  const removeSiteUserConfirm = () => {
    setPopupStatus((prevState) => ({
      ...prevState,
      deleteSiteUserConfirmPopUpStatus: false,
    }));
    if (popupInfo.deleteSiteUserId !== "") {
      setLoading(true);
      apiSession
        .deleteSiteUser(popupInfo.deleteSiteUserId)
        .then(() => {
          setLoading(false);
          callSnackbar("success", "User deleted sucessfully");
          getSiteUsers();
        })
        .catch((error) => {
          setLoading(false);
         
            if (parseInt(error?.response?.status) === 400) {
              callSnackbar("error", error?.response?.data?.message);
            } else if (error?.response?.status === 504) {
              callSnackbar("error", "User not found");
            } else {
              callSnackbar("error", "Error in deletion");
            }
         
        });
    }
  };

  //* Alarm

  const alaramChangeHanlder = (e) => {
    const { name, value, checked } = e.target;
    if (name === "selectedAlaram") {
      if (projectTypeData === "NMGaaS ETO") {
        setSelectedAlaram(value);
      } else {
        setSelectedAlaram(checked ? "ADVANCED_ALARM" : "NO_ALARM");
      }

    }
    else if (name === "sendAlarmsToAMS") {
      setAmsService((prevState) => ({
        ...prevState,
        sendAlarmsToAMS: checked
      }));
      setSelectedAlaram("ADVANCED_ALARM");
    }

  };

  const addEmailToAlaram = () => {
    if (
      ["BASIC_ALARM", "ADVANCED_ALARM", "STANDARD_ALARM"].includes(selectedAlaram) &&
      emailUsers.length > 2
    ) {
      const newSelectedName =
        selectedAlaram === "BASIC_ALARM" ? "Basic alarm" : "Advanced alarm";
      callSnackbar(
        "error",
        `${newSelectedName} usecase can have maximum three email address`
      );
    } else {
      setPopupStatus((prevState) => ({
        ...prevState,
        inviteUserToAlaramStatus: true,
      }));
    }
  };

  const closeInviteEmailToAlaram = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      inviteUserToAlaramStatus: false,
    }));

  const inviteUserToAlaramList = (data) => {
    const UserPresent = emailUsers.includes(data.emailAddress);
    if (UserPresent) {
      setPopupStatus((prevState) => ({
        ...prevState,
        inviteUserToAlaramStatus: false,
      }));
      callSnackbar("error", "User already added");
    } else {
      setEmailUsers((prevState) => [...prevState, data.emailAddress]);
      setPopupStatus((prevState) => ({
        ...prevState,
        inviteUserToAlaramStatus: false,
      }));
      callSnackbar("success", "User added successfully");
    }
  };

  const removeUserFromAlarmStatus = (userData) => {
    setPopupInfo((prevState) => ({ ...prevState, deleteEmailId: userData }));
    setPopupStatus((prevState) => ({
      ...prevState,
      deleteUserFromAlarmStatus: true,
    }));
  };

  const closeDeleteInviteUserpopup = () => {
    setPopupInfo((prevState) => ({ ...prevState, deleteEmailId: "" }));

    setPopupStatus((prevState) => ({
      ...prevState,
      deleteUserFromAlarmStatus: false,
    }));
  };

  const removeEmailFromAlaram = () => {
    const emailUsersNew = emailUsers.filter(
      (user) => user !== popupInfo.deleteEmailId
    );
    setPopupStatus((prevState) => ({
      ...prevState,
      deleteUserFromAlarmStatus: false,
    }));
    setPopupInfo((prevState) => ({ ...prevState, deleteEmailId: "" }));
    setEmailUsers(emailUsersNew);
    callSnackbar("success", "User deleted successfuly");
  };

  //* ongrid

  const demandChargeDataCallback = (data) => {
    let newDemandCharge = {};
    newDemandCharge = data;
    setDemandChargeOutput(newDemandCharge);
    configuredStatusModified("dcConfiguredStatus");
    setTemplateSelected(false);
    setDemandChargeUseCaseSelection(
      newDemandCharge?.demandChargeUseCaseSelection
    );
    setBillingPeriod({
      billingType: "FIRST",
      fixDay: 1,
      customDays: null,
    })
    setDcthreshold({
      type: "FIXED",
      valueType: "VALUE",
      fixedValues: { peakPreset: '', billingPeriodPreset: '', },
      customValues: generateDefaultData(),
    })
  };

  const enableTemplatePopUp = () => {
    if (!UserScope.access.saveProjects) {
      callSnackbar(
        `error`,
        `Unauthorised to perform this action, Contact administrator.`
      );
      return;
    } else if (
     ( siteCreated && projectTypeData !=="NMGaaS ETO")||
      projectStatusData?.projectStatus === "COMPLETED" ||
      projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
    ) {
      callSnackbar(
        `error`,
        `Change the project state to in-progress to update the project.`
      );
      return;
    } else {
      setPopupStatus((prevState) => ({
        ...prevState,
        templatePopUpStatus: true,
      }));
    }
  };
  const disableTemplatePopUp = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      templatePopUpStatus: false,
    }));

  const selectTemplate = (data) => {
    let newDemandCharge = {};
    try {
      newDemandCharge = typeof data === "string" ? JSON.parse(data) : data;
    } catch (error) {
      callSnackbar("error", "Invalid template data");
      return;
    }

    const templateUseCase = newDemandCharge?.demandChargeUseCaseSelection;
    const isTariffManagementEnabled = gridSettings?.tariffManagement === true;
    const isDemandChargeEnabled = gridSettings?.demandCharge === true;

    // If Tariff Management is OFF, do not allow selecting TOU templates.
    if (!isTariffManagementEnabled && templateUseCase === "TOU") {
      callSnackbar(
        "error",
        "TOU templates require Tariff Management to be enabled."
      );
      return;
    }

    // If both Demand Charge and Tariff Management are ON, allow only DCMP/FDC/TOU.
    if (isDemandChargeEnabled && isTariffManagementEnabled) {
      const allowedUseCases = ["DCMP", "FDC", "TOU"];
      if (templateUseCase && !allowedUseCases.includes(templateUseCase)) {
        callSnackbar(
          "error",
          "Selected template use case is not supported for current grid settings."
        );
        return;
      }
    }

    // If Tariff Management is ON but Demand Charge is OFF, allow only TOU.
    if (!isDemandChargeEnabled && isTariffManagementEnabled) {
      if (templateUseCase !== "TOU") {
        callSnackbar(
          "error",
          "Only TOU templates are supported when Demand Charge is disabled."
        );
        return;
      }
    }

    if (!newDemandCharge.tariffDef) {
      newDemandCharge.tariffDef = [];
    }

    setPopupStatus((prevState) => ({
      ...prevState,
      templatePopUpStatus: false,
    }));
    setTemplateSelected(true);
    setDemandChargeOutput(newDemandCharge);
    setDemandChargeUseCaseSelection(templateUseCase);
    configuredStatusModified("dcConfiguredStatus");
    setBillingPeriod({
      billingType: "FIRST",
      fixDay: 1,
      customDays: null,
    })
    setDcthreshold({
      type: "FIXED",
      valueType: "VALUE",
      fixedValues: { peakPreset: '', billingPeriodPreset: '', },
      customValues: generateDefaultData(),
    })
  };
  const saveNewTemplate = () => {
    // let result = null;
    // let dcData = _.cloneDeep(demandChargeOutput);
    // result = CalendarTariff.validateDemandCharge();Do you want to save this template
    // if (result !== null) {
    //   callSnackbar("error", DcAlertLabels[result]);
    // } else {
      setPopupStatus((prevState) => ({
        ...prevState,
        newTemplateConfirmPopUpStatus: true,
      }));
    // }
  };
  const closeNewTemplatePopUp = () => {
    setNewTemplateName("");
    setPopupStatus((prevState) => ({
      ...prevState,
      newTemplateConfirmPopUpStatus: false,
    }));
  };
  const handlenewTemplate = (e) => {
    const { value } = e.target;
    setNewTemplateName(value);
  };

  const saveTemplate = () => {
    setLoading(true);
    setPopupStatus((prevState) => ({
      ...prevState,
      newTemplateConfirmPopUpStatus: false,
    }));
    let newTariffDynamicConfiguration =
      tariffDynamicConfiguration === null
        ? null
        : { ...tariffDynamicConfiguration };
    if (newTariffDynamicConfiguration === "null") {
      newTariffDynamicConfiguration = null;
    } else if (newTariffDynamicConfiguration?.tariffType === "dynamic") {
      delete newTariffDynamicConfiguration?.spotPriceTariff;
    } else {
      delete newTariffDynamicConfiguration?.dynamicHourTariff;
    }

    if (
      gridSettings?.demandCharge === false &&
      gridSettings?.tariffManagement === false
    ) {
      setTariffDynamicConfiguration(null);
      setSellTariff(null);
      setDeltaSellTariff(null);
    }

    const demandCharge = {
      title: newTemplateName,
      demandCharge: JSON.stringify(demandChargeOutput),
      tariffDynamicConfiguration:
        newTariffDynamicConfiguration === null
          ? null
          : JSON.stringify(newTariffDynamicConfiguration),
      sellTariff: sellTariff,
      deltaSellTariff: deltaSellTariff,
    };
    if (
      gridSettings?.demandCharge === false &&
      gridSettings?.tariffManagement === false
    ) {
      demandCharge.tariffDynamicConfiguration = null;
      demandCharge.sellTariff = null;
      demandCharge.deltaSellTariff = null;
    }
    if (sellTariff === "at0") {
      demandCharge.deltaSellTariff = null;
    }
    try {
      apiSession
        .createTemplate(demandCharge)
        .then(() => {
          callSnackbar("success", `Template created successfully`);
          setLoading(false);

          getDcTemplates();
        })
        .catch(() => {
          callSnackbar("error", `Error in saving the template`);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const exportManagementChange = () => {
    setAlertMessage(
      `Alert`,
      false,
      ``,
      `For changing the use case, go back to information page and make your choice.`
    );
  };

  const handleChange = (e) => {
    //const onlyNumber = /^[0-9]?\d*\.?\d*$/;
    const onlyNumberInt = /^[0-9]?\d*$/;
    const onlyNumberIntNegative = /^(-)?([0-9]?\d*)$/;

    const { name, value, checked } = e.target;

    switch (e.target.name) {
      case "maxExportPower":
      case "maxLimitEnergyExportPower":
        if (onlyNumberIntNegative.test(e.target.value)) {
           if(["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(projectTypeValue) ){
              setMaxLimitEnergyExportPower(value);
         }
          setMaxExportPower(value);
          if(["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(projectTypeValue)){
             setMaxLimitEnergyExportPower(value);
             setLimitImportExport(prevState => {
            return {
              ...prevState,
              maxLimitEnergyExportPower: value,
            }
          })
          }else{
             setLimitImportExport(prevState => {
            return {
              ...prevState,
              maxLimitEnergyExportPower: value,
            }
          })
          }
         
        }
        break;
      case "minLimitEnergyImportPower":
        if (onlyNumberIntNegative.test(e.target.value)) {
          setLimitImportExport(prevState => {
            return {
              ...prevState,
              minLimitEnergyImportPower: value,
            }
          })
        }
        break;

      case "importStartHysteresis":
        if (
          onlyNumberIntNegative.test(e.target.value) &&
          e.target.value <= 1000
        ) {
          setImportStartHysteresis(value);
        }
        break;
      case "importStopHysteresis":
        if (
          onlyNumberIntNegative.test(e.target.value) &&
          e.target.value <= 1000
        ) {
          setImportStopHysteresis(value);
        }
        break;

      case "maxLimitEnergyImportPower":
        if (onlyNumberInt.test(e.target.value)) {
          if(["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(projectTypeValue) ){
              setMaxLimitEnergyImportPower(value);
              setLimitImportExport(prevState => {
            return {
              ...prevState,
              maxLimitEnergyImportPower: value,
            }
          })
          if (value === "") {
            // setPeakImportHysteresis(prev=>{
            //   return {
            //     startHysteresisPercent:"",
            //     startHysteresisKw:"",
            //     stopHysteresisPercent:"",
            //     stopHysteresisKw:""
            //   }
            // });
          } else {
            const startKwValue =
              (Number(value) *
                Number(peakImportHysteresis?.startHysteresisPercent)) /
              100;
            const stopKwValue =
              (Number(value) *
                Number(peakImportHysteresis?.stopHysteresisPercent)) /
              100;
            setPeakImportHysteresis((prev) => {
              return {
                ...prev,
                startHysteresisKw: startKwValue,
                stopHysteresisKw: stopKwValue,
              };
            });
          }
          }else{
          setLimitImportExport(prevState => {
            return {
              ...prevState,
              maxLimitEnergyImportPower: value,
            }
          })
        }
        }
        break;
      case "minLimitEnergyExportPower":
        if (onlyNumberIntNegative.test(e.target.value)) {
          setLimitImportExport(prevState => {
            return {
              ...prevState,
              minLimitEnergyExportPower: value,
            }
          })
        }
        break;
      case "peakImportHysteresisStartPercentage":
        if (value === "") {
          setPeakImportHysteresis((prev) => {
            return {
              ...prev,
              startHysteresisPercent: value,
              startHysteresisKw: value,
            };
          });
          return;
        }
        if (e.target.value <= 100) {
          const startKwValue =
            (Number(limitImportExport?.maxLimitEnergyImportPower) * Number(value)) / 100;
          if (peakImportHysteresis?.startHysteresisPercent !== 0) {
            setPeakImportHysteresis((prev) => {
              return {
                ...prev,
                startHysteresisPercent: value,
                startHysteresisKw: startKwValue,
              };
            });
          }
        }

        break;
      case "peakImportHysteresisStopPercentage":
        if (value === "") {
          setPeakImportHysteresis((prev) => {
            return {
              ...prev,
              stopHysteresisPercent: value,
              stopHysteresisKw: value,
            };
          });
          return;
        }
        if (e.target.value <= 100) {
          const stoptKwValue =
            (Number(limitImportExport?.maxLimitEnergyImportPower) * Number(value)) / 100;
          if (peakImportHysteresis?.stopHysteresisPercent !== 0) {
            setPeakImportHysteresis((prev) => {
              return {
                ...prev,
                stopHysteresisPercent: value,
                stopHysteresisKw: stoptKwValue,
              };
            });
          }
        }
        break;
      case "reconnectionTimer":
      case "reconnection2Timer":
        if (onlyNumberInt.test(value)) {
          setReconnectionTimers((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }

        break;

      case "lostDetectionTimer":
      case "gridDetectionTimer":
        if (onlyNumberInt.test(value)) {
          setGridDetails((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }

        break;

      case "gensetLoad":
        if (genset.max_power === "" || parseInt(genset.max_power) === 0) {
          callSnackbar("error", "Genset max power is not configured in SLD");
        } else {
          if (onlyNumberInt.test(value)) {
            setGensetLoad(value);
          }
        }

        break;
      case "bessImport":
      case "bessExport":
      case "pvExport":
        setLimitImportExport((prevState) => {
          return {
            ...prevState,
            [name]: checked,
          };
        });
        if(name === "bessExport" && checked === false && limitImportExport.pvExport === false){
          setLimitExport(false);
        }
          if(name === "pvExport" && checked === false && limitImportExport.bessExport === false){
          setLimitExport(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    switch (name) {
      case "batteryBuffering":
      case "batteryBufferingExport":
        if (
          siteType === embLabels.ISLANDABLE_GSX &&
          architectureType === embLabels.PV_GENSET_ATS &&
          gridSettings?.mode == "FUEL_SAVER"
        ) {
          setBatteryDetails((prevState) => ({
            ...prevState,
            [name]: checked,
          }));
        } else {
          if (batteryDetails?.batteryBufferingStatus !== true) {
            setBatteryDetails((prevState) => ({
              ...prevState,
              [name]: checked,
            }));
          }
        }

        break;
      case "pvCurtailmentExport":
        setPvCurtailmentExport(checked);
        break;
      case "pvCurtailment":
        setPvCurtailment(checked);
        break;
      case "lossOfComm":
        setlossOfComm(checked);
        break;
      case "lossOfCommEMA":
        setLossOfCommEMA(checked);
        break;
      case "gensetLSIEnable":
        setGensetLSIEnable(checked);
        break;
      case "BESS_PV_limitation_enable":
      case "BESS_PV_disconnection":
        {
        let BESSCharge = { ...BESSCharging };
        BESSCharge[name] = checked;
        setBESSCharging(BESSCharge);
        break;
      }
      default:
        break;
    }
  };

  const handlepPVOpeningPopup = (e) => {
    const { name, checked } = e.target;
    if (name === "utilityLSIEnable") {
      setUtilityLSIEnable(checked);
      if (
        (siteType === embLabels.PV_HYBRIDIZATION ||
          (siteType === embLabels.ISLANDABLE_GSX &&
            architectureType === embLabels.PV_GENSET_ATS)) &&
        checked
      ) {
        setPopupStatus((prevState) => ({
          ...prevState,
          utilityPvOpeningConfirmpopUpSattus: true,
        }));
      }
    }
    if (name === "gensetLSIEnable") {
      setGensetLSIEnable(checked);
      if (
        (siteType === embLabels.PV_HYBRIDIZATION ||
          (siteType === embLabels.ISLANDABLE_GSX &&
            architectureType === embLabels.PV_GENSET_ATS)) &&
        checked
      ) {
        setPopupStatus((prevState) => ({
          ...prevState,
          gensetPvOpeningConfirmpopUpSattus: true,
        }));
      }
    }
  };

  const cancelUtilityPvopenPopUp = () => {
    setPopupStatus((prevState) => ({
      ...prevState,
      utilityPvOpeningConfirmpopUpSattus: false,
    }));
    setUtilityLSIEnable(false);
  };

  const confirmUtilityPVOpen = () => {
    setPopupStatus((prevState) => ({
      ...prevState,
      utilityPvOpeningConfirmpopUpSattus: false,
    }));
    setUtilityLSIEnable(true);
  };

  const cancelGensetPvopenPopUp = () => {
    setPopupStatus((prevState) => ({
      ...prevState,
      gensetPvOpeningConfirmpopUpSattus: false,
    }));
    setGensetLSIEnable(false);
  };

  const confirmGensetPVOpen = () => {
    setPopupStatus((prevState) => ({
      ...prevState,
      gensetPvOpeningConfirmpopUpSattus: false,
    }));
    setGensetLSIEnable(true);
  };

  //* off grid

  const loadSheddingChangeHandler = (e) => {

    const { name, value } = e.target;
    if (name === "loadSheddingStatus") {
      if (value === "Y")
        setPopupStatus((prevState) => ({
          ...prevState,
          loadSheddingConfirmTruePopUpStatus: true,
        }));

      if (value === "N")
        setPopupStatus((prevState) => ({
          ...prevState,
          loadSheddingConfirmPopUpStatus: true,
        }));
    }
    if (name === "loadSheddingGridtiedStatus") {
      if (value === "Y")
        setPopupStatus((prevState) => ({
          ...prevState,
          loadSheddingIslandConfirmTruePopUpStatus: true,
        }));

      if (value === "N")
        setPopupStatus((prevState) => ({
          ...prevState,
          loadSheddingIslandConfirmPopUpStatus: true,
        }));
    }
    if (name === "loadSheddable") {
      setGridTiedLoadsSheddable(value);
    }
  };

  const cancelLoadSheddingConfirm = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingConfirmPopUpStatus: false,
    }));
  const cancelLoadSheddingIslandConfirm = () => {
    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingIslandConfirmPopUpStatus: false,
    }));

  }
  const acceptLoadSheddingConfirm = () => {
    loadSheddingReset();
    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingConfirmPopUpStatus: false,
    }));

    setLoadShedding((prevState) => ({
      ...prevState,
      loadShedding: false,
      loadSheddingStatus: "N",
    }));
    configuredStatusModified("lsConfiguredStatus");
  };
  const loadSheddingdefaultReset = (response) => {
  const newLoad = Array.isArray(response) ? response : [];

  if (newLoad.length === 0) return;

  const loadsFromAPI = newLoad.map((load) => {
    const firstAttr = load.attributes?.[0] || {};
    return {
      ...load,
      attributes: [
        {
          ...firstAttr,
          loadPriority: {
            ...firstAttr.loadPriority,
            attributeValue: 0,
          },
          loadCategory: {
            ...firstAttr.loadCategory,
            isGridTied: false,
            isIslandable: false,
            isGridTiedAndIslandable: false,
          },
        },
      ],
    };
  });

  setLoads(loadsFromAPI);
  setLoadList((prevState) => ({
    ...prevState,
    emergencyList: [],
    essentialList: [],
    nonEssentialList: [],
    gridTiedAllowIslandingList: [],
    gridTiedNotAllowIslandingList: [],
  }));
};
const loadSheddingReset = () => {
  const newLoad = {...currentProject.resources};
// assignLoads(newLoad)
   let loadsFromAPI = [];

    newLoad?.resources?.forEach((load) => {
      const newResource =
      {
        ...load,
        attributes: [
          {
            ...load.attributes[0],
            loadPriority: {
              ...load.attributes[0].loadPriority,
              attributeValue: 0,
            },
            loadCategory: {
              ...load.attributes[0].loadCategory,
              isGridTied: false,
              isIslandable: false,
              isGridTiedAndIslandable: false,
            },
          },
        ],
      }
      loadsFromAPI.push(newResource);
    });

    setLoads(loadsFromAPI);
    setLoadList((prevState) => {
      return {
        ...prevState,
        emergencyList: [],
        essentialList: [],
        nonEssentialList: [],
        gridTiedAllowIslandingList: [],
        gridTiedNotAllowIslandingList: [],
      };
    });
  }


  const acceptLoadSheddingGriedTiedConfirm = () => {
    loadSheddingReset();
    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingIslandConfirmPopUpStatus: false,
    }));
    if (siteType === embLabels.GRID_CONNECTED && projectTypeData === "MGaaS ANSI" || projectTypeData === "MGaaS IEC" || projectTypeData === "MGaaS ETO") {
      setLoadShedding((prevState) => ({
        loadShedding: false,
        loadSheddingActivatedGridTied: false,
        loadSheddingStatus: "N",
        loadSheddingGridtiedStatus: "N",
      }));
    } else {
      if (loadShedding.loadSheddingStatus === "Y") {
        setLoadShedding((prevState) => ({
          loadShedding: true,
          loadSheddingActivatedGridTied: false,
          loadSheddingStatus: "Y",
          loadSheddingGridtiedStatus: "N",
        }));
      } else {
        setLoadShedding((prevState) => ({
          ...prevState,
          loadSheddingActivatedGridTied: false,
          loadSheddingGridtiedStatus: "N",
        }));
      }

    }

    // setLoadShedding((prevState) => ({
    //   ...prevState,
    //   loadSheddingActivatedGridTied: false,
    //   loadSheddingGridtiedStatus: "N",
    // }));
    configuredStatusModified("lsConfiguredStatus");
  }
  const cancelLoadSheddingTrueConfirm = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingConfirmTruePopUpStatus: false,
    }));

  const cancelLoadSheddingGridTiedTrueConfirm = () => {

    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingIslandConfirmTruePopUpStatus: false,
    }));

  }
  const acceptLoadSheddingTrueConfirm = () => {
    loadSheddingReset();
    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingConfirmTruePopUpStatus: false,
    }));

    setLoadShedding((prevState) => ({
      ...prevState,
      loadShedding: true,
      loadSheddingStatus: "Y",
    }));
    configuredStatusModified("lsConfiguredStatus");
  };
  const acceptLoadSheddingGridTiedTrueConfirm = () => {
    loadSheddingReset();
    setPopupStatus((prevState) => ({
      ...prevState,
      loadSheddingIslandConfirmTruePopUpStatus: false,
    }));
    if (siteType === embLabels.GRID_CONNECTED && projectTypeData === "MGaaS ANSI" || projectTypeData === "MGaaS IEC" || projectTypeData === "MGaaS ETO") {
      setLoadShedding((prevState) => ({
        loadShedding: false,
        loadSheddingActivatedGridTied: true,
        loadSheddingStatus: "N",
        loadSheddingGridtiedStatus: "Y",
      }));
    } else if (siteType === embLabels.ISLANDABLE && projectTypeData === "MGaaS ANSI" || projectTypeData === "MGaaS IEC" || projectTypeData === "MGaaS ETO") {
      setLoadShedding((prevState) => ({
        ...prevState,
        loadShedding: true,
        loadSheddingActivatedGridTied: true,
        loadSheddingGridtiedStatus: "Y",
      }));
    }
    else {
      setLoadShedding((prevState) => ({
        ...prevState,
        loadSheddingActivatedGridTied: true,
        loadSheddingGridtiedStatus: "Y",
      }));
    }

    configuredStatusModified("lsConfiguredStatus");
  };
  const onDrag = (event, loadData) => {
    event.preventDefault();
    setDndDetails((prevState) => ({
      ...prevState,
      draggedLoad: loadData,
      draggedLoadFrom: "",
    }));
  };
  const loadOperationShedding = (draggedLoad, siteOptionType) => {
    const newDraggedLoad = { ...draggedLoad }
    if (siteOptionType === "islandable") {
      newDraggedLoad.isGridTied = false;
      newDraggedLoad.isIslandable = true;
      newDraggedLoad.isGridTiedAndIslandable = false;

    } else if (siteOptionType === "grid") {
      newDraggedLoad.isGridTied = true;
      newDraggedLoad.isIslandable = false;
      newDraggedLoad.isGridTiedAndIslandable = false;

    } else if (siteOptionType === "gridAndIsland") {
      newDraggedLoad.isGridTied = false;
      newDraggedLoad.isIslandable = false;
      newDraggedLoad.isGridTiedAndIslandable = true;

    } else {
      // do nothing
    }
    return newDraggedLoad
  }
  const onDrop = (e, loadType, siteOptionType) => {
    let { draggedLoad, draggedLoadFrom } = dndDetails;
    const {
      emergencyList,
      essentialList,
      nonEssentialList,
      gridTiedAllowIslandingList,
      gridTiedNotAllowIslandingList,
    } = loadList;
    configuredStatusModified("lsConfiguredStatus");
    switch (loadType) {
      case "emergency":
        if (draggedLoadFrom === "") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 1;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newemergencyList = [...emergencyList, draggedLoad];
          setLoadList((prevState) => ({
            ...prevState,
            emergencyList: newemergencyList,
          }));
          const newLoadList = loads?.filter(
            (load) => load.resourceId !== draggedLoad.resourceId
          );

          setLoads(newLoadList);
          setDndDetails((prevState) => ({ ...prevState, draggedLoad: {} }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "essential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 1;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newemergencyList = [...emergencyList, draggedLoad];

          const newEssentialList = essentialList.filter(
            (essentialData) =>
              essentialData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            emergencyList: newemergencyList,
            essentialList: newEssentialList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "nonEssential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 1;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newemergencyList = [...emergencyList, draggedLoad];

          const newNonEssentialList = nonEssentialList.filter(
            (nonEssentialData) =>
              nonEssentialData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            emergencyList: newemergencyList,
            nonEssentialList: newNonEssentialList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 1;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newemergencyList = [...emergencyList, draggedLoad];

          const newGridTiedAllowIslandingList =
            gridTiedAllowIslandingList.filter(
              (essentialData) =>
                essentialData.resourceId !== draggedLoad.resourceId
            );
          setLoadList((prevState) => ({
            ...prevState,
            emergencyList: newemergencyList,
            gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedNotAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 1;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newemergencyList = [...emergencyList, draggedLoad];

          const newGridTiedNotAllowIslandingList =
            gridTiedNotAllowIslandingList.filter(
              (nonEssentialData) =>
                nonEssentialData.resourceId !== draggedLoad.resourceId
            );
          setLoadList((prevState) => ({
            ...prevState,
            emergencyList: newemergencyList,
            gridTiedNotAllowIslandingList: newGridTiedNotAllowIslandingList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        }
        break;

      case "essential":
        if (draggedLoadFrom === "") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 2;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newEssentialList = [...essentialList, draggedLoad];
          setLoadList((prevState) => ({
            ...prevState,
            essentialList: newEssentialList,
          }));
          const newLoadList = loads?.filter(
            (load) => load.resourceId !== draggedLoad.resourceId
          );

          setLoads(newLoadList);
          setDndDetails((prevState) => ({ ...prevState, draggedLoad: {} }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "emergency") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 2;
          const newEssentialList = [...essentialList, draggedLoad];

          const newEmergencyList = emergencyList.filter(
            (emergencyData) =>
              emergencyData.resourceId !== draggedLoad.resourceId
          );

          setLoadList((prevState) => ({
            ...prevState,
            essentialList: newEssentialList,
            emergencyList: newEmergencyList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "nonEssential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 2;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newEssentialList = [...essentialList, draggedLoad];

          const newNonEssentialData = nonEssentialList.filter(
            (nonEssentialData) =>
              nonEssentialData.resourceId !== draggedLoad.resourceId
          );

          setLoadList((prevState) => ({
            ...prevState,
            essentialList: newEssentialList,
            nonEssentialList: newNonEssentialData,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 2;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newEssentialList = [...essentialList, draggedLoad];

          const newGridTiedAllowIslandingList =
            gridTiedAllowIslandingList.filter(
              (emergencyData) =>
                emergencyData.resourceId !== draggedLoad.resourceId
            );

          setLoadList((prevState) => ({
            ...prevState,
            essentialList: newEssentialList,
            gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedNotAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 2;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newEssentialList = [...essentialList, draggedLoad];

          const newGridTiedNotAllowIslandingList =
            gridTiedNotAllowIslandingList.filter(
              (nonEssentialData) =>
                nonEssentialData.resourceId !== draggedLoad.resourceId
            );

          setLoadList((prevState) => ({
            ...prevState,
            essentialList: newEssentialList,
            gridTiedNotAllowIslandingList: newGridTiedNotAllowIslandingList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        }
        break;
      case "nonEssential":
        if (draggedLoadFrom === "") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 3;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newNonEssentialList = [...nonEssentialList, draggedLoad];
          setLoadList((prevState) => ({
            ...prevState,
            nonEssentialList: newNonEssentialList,
          }));
          const newLoadList = loads?.filter(
            (load) => load.resourceId !== draggedLoad.resourceId
          );

          setLoads(newLoadList);
          setDndDetails((prevState) => ({ ...prevState, draggedLoad: {} }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "emergency") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 3;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newNonEssentialList = [...nonEssentialList, draggedLoad];
          const newEmergencyList = emergencyList.filter(
            (emergencyData) =>
              emergencyData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            nonEssentialList: newNonEssentialList,
            emergencyList: newEmergencyList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "essential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 3;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newNonEssentialList = [...nonEssentialList, draggedLoad];
          const newEssentialList = essentialList.filter(
            (essentialData) =>
              essentialData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            nonEssentialList: newNonEssentialList,
            essentialList: newEssentialList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 3;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newNonEssentialList = [...nonEssentialList, draggedLoad];
          const newGridTiedAllowIslandingList =
            gridTiedAllowIslandingList.filter(
              (essentialData) =>
                essentialData.resourceId !== draggedLoad.resourceId
            );
          setLoadList((prevState) => ({
            ...prevState,
            nonEssentialList: newNonEssentialList,
            gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedNotAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 3;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newNonEssentialList = [...nonEssentialList, draggedLoad];
          const newGridTiedNotAllowIslandingList =
            gridTiedNotAllowIslandingList.filter(
              (essentialData) =>
                essentialData.resourceId !== draggedLoad.resourceId
            );
          setLoadList((prevState) => ({
            ...prevState,
            nonEssentialList: newNonEssentialList,
            gridTiedNotAllowIslandingList: newGridTiedNotAllowIslandingList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        }
        break;

      case "gridTiedAllowIslanding":
        setGridTiedLoadsSheddable("0");
        console.log(loadList, loads)
        if (draggedLoadFrom === "") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 5;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedAllowIslanding = [
            ...gridTiedAllowIslandingList,
            draggedLoad,
          ];
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: newGridTiedAllowIslanding,
          }));
          const newLoadList = loads?.filter(
            (load) => load.resourceId !== draggedLoad.resourceId
          );

          setLoads(newLoadList);
          setDndDetails((prevState) => ({ ...prevState, draggedLoad: {} }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "emergency") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 5;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newgridTiedAllowIslandingList = [
            ...gridTiedAllowIslandingList,
            draggedLoad,
          ];
          const newEmergencyList = emergencyList.filter(
            (emergencyData) =>
              emergencyData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: newgridTiedAllowIslandingList,
            emergencyList: newEmergencyList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "essential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 5;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedAllowIslandingList = [
            ...gridTiedAllowIslandingList,
            draggedLoad,
          ];
          const newEssentialList = essentialList.filter(
            (essentialData) =>
              essentialData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
            essentialList: newEssentialList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "nonEssential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 5;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedAllowIslandingList = [
            ...gridTiedAllowIslandingList,
            draggedLoad,
          ];

          const newNonEssentialData = nonEssentialList.filter(
            (nonEssentialData) =>
              nonEssentialData.resourceId !== draggedLoad.resourceId
          );

          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
            nonEssentialList: newNonEssentialData,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedNotAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 5;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedAllowIslandingList = [
            ...gridTiedAllowIslandingList,
            draggedLoad,
          ];

          const newGridTiedNotAllowIslandingList =
            gridTiedNotAllowIslandingList.filter(
              (nonEssentialData) =>
                nonEssentialData.resourceId !== draggedLoad.resourceId
            );

          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
            gridTiedNotAllowIslandingList: newGridTiedNotAllowIslandingList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        }
        break;

      case "gridTiedNotAllowIslanding":
        setGridTiedLoadsSheddable("0");
        if (draggedLoadFrom === "") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 4;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedNotAllowIslanding = [
            ...gridTiedNotAllowIslandingList,
            draggedLoad,
          ];
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedNotAllowIslandingList: newGridTiedNotAllowIslanding,
          }));
          const newLoadList = loads?.filter(
            (load) => load.resourceId !== draggedLoad.resourceId
          );

          setLoads(newLoadList);
          setDndDetails((prevState) => ({ ...prevState, draggedLoad: {} }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "emergency") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 4;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newgridTiedNotAllowIslandingList = [
            ...gridTiedNotAllowIslandingList,
            draggedLoad,
          ];
          const newEmergencyList = emergencyList.filter(
            (emergencyData) =>
              emergencyData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedNotAllowIslandingList: newgridTiedNotAllowIslandingList,
            emergencyList: newEmergencyList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "essential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 4;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedNotAllowIslandingList = [
            ...gridTiedNotAllowIslandingList,
            draggedLoad,
          ];
          const newEssentialList = essentialList.filter(
            (essentialData) =>
              essentialData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: newGridTiedNotAllowIslandingList,
            essentialList: newEssentialList,
          }));

          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "nonEssential") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 4;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedNotAllowIslandingList = [
            ...gridTiedNotAllowIslandingList,
            draggedLoad,
          ];

          const newNonEssentialData = nonEssentialList.filter(
            (nonEssentialData) =>
              nonEssentialData.resourceId !== draggedLoad.resourceId
          );

          setLoadList((prevState) => ({
            ...prevState,
            gridTiedNotAllowIslandingList: newGridTiedNotAllowIslandingList,
            nonEssentialList: newNonEssentialData,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        } else if (draggedLoadFrom === "gridTiedAllowIslanding") {
          draggedLoad.attributes[0].loadCategory.attributeValue = 4;
          draggedLoad = loadOperationShedding(draggedLoad, siteOptionType);
          const newGridTiedNotAllowIslandingList = [
            ...gridTiedNotAllowIslandingList,
            draggedLoad,
          ];

          const newGridTiedAllowIslandingList =
            gridTiedAllowIslandingList.filter(
              (nonEssentialData) =>
                nonEssentialData.resourceId !== draggedLoad.resourceId
            );

          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
            gridTiedNotAllowIslandingList: newGridTiedNotAllowIslandingList,
          }));
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));

          const runEffectsNew = { loadPriority: true };
          setRunEffects(runEffectsNew);
        }
        break;

      case "loads":
        draggedLoad.attributes[0].loadCategory.attributeValue = 0;
        draggedLoad.attributes[0].loadPriority.attributeValue = 0;
        draggedLoad.attributes[0].loadCategory.isGridTied = false;
        draggedLoad.attributes[0].loadCategory.isIslandable = false;
        draggedLoad.attributes[0].loadCategory.isGridTiedAndIslandable = false;

        if (draggedLoadFrom === "emergency") {
          const nonEmergencyList = emergencyList.filter(
            (emergencyData) =>
              emergencyData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            emergencyList: nonEmergencyList,
          }));
          const newLoadList = [...loads, draggedLoad];

          setLoads(newLoadList);
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));
        } else if (draggedLoadFrom === "essential") {
          const newEssentialData = essentialList.filter(
            (essentialData) =>
              essentialData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            essentialList: newEssentialData,
          }));
          const newLoadList = [...loads, draggedLoad];

          setLoads(newLoadList);
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));
        } else if (draggedLoadFrom === "nonEssential") {
          const newNonEssentialList = nonEssentialList.filter(
            (nonEssentialData) =>
              nonEssentialData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            nonEssentialList: newNonEssentialList,
          }));
          const newLoadList = [...loads, draggedLoad];

          setLoads(newLoadList);
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));
        }
        else if (draggedLoadFrom === "gridTiedAllowIslanding") {
          const nonEmergencyList = gridTiedAllowIslandingList.filter(
            (emergencyData) =>
              emergencyData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedAllowIslandingList: nonEmergencyList,
          }));
          const newLoadList = [...loads, draggedLoad];

          setLoads(newLoadList);
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));
        } else if (draggedLoadFrom === "gridTiedNotAllowIslanding") {
          const nonEmergencyList = gridTiedNotAllowIslandingList.filter(
            (emergencyData) =>
              emergencyData.resourceId !== draggedLoad.resourceId
          );
          setLoadList((prevState) => ({
            ...prevState,
            gridTiedNotAllowIslandingList: nonEmergencyList,
          }));
          const newLoadList = [...loads, draggedLoad];

          setLoads(newLoadList);
          setDndDetails((prevState) => ({
            ...prevState,
            draggedLoad: {},
            draggedLoadFrom: "",
          }));
        }
        break;
      default:
        break;
    }
  };

  const onDragFrom = (event, loadData, loadFrom) => {
    event.preventDefault();
    setDndDetails((prevState) => ({
      ...prevState,
      draggedLoad: loadData,
      draggedLoadFrom: loadFrom,
    }));
  };

  const onDragOver = (event) => event.preventDefault();

  const updateLoadsPriority = (caseType) => {
    let i = 1;
    let newEmergencyList = [...loadList.emergencyList];
    newEmergencyList.forEach((newEmergencyListData, index) => {
      newEmergencyList[index].attributes[0].loadPriority.attributeValue = i;
      i = i + 1;
    });

    let ies = newEmergencyList.length + 1;
    let newEssentialList = [...loadList.essentialList];
    newEssentialList.forEach((newEssentialListData, index) => {
      newEssentialList[index].attributes[0].loadPriority.attributeValue = ies;
      ies = ies + 1;
    });

    let ine = newEmergencyList.length + newEssentialList.length + 1;
    let newNonEssentialList = [...loadList.nonEssentialList];
    newNonEssentialList.forEach((newNonEssentialListData, index) => {
      newNonEssentialList[index].attributes[0].loadPriority.attributeValue =
        ine;
      ine = ine + 1;
    });

    let gtna =
      newEmergencyList.length +
      newEssentialList.length +
      newNonEssentialList.length +
      1;
    let newGridTiedNotAllowIslandingList = [
      ...loadList.gridTiedNotAllowIslandingList,
    ];
    newGridTiedNotAllowIslandingList.forEach(
      (newGridTiedNotAllowIslandingListData, index) => {
        newGridTiedNotAllowIslandingList[
          index
        ].attributes[0].loadPriority.attributeValue = gtna;
        gtna = gtna + 1;
      }
    );

    let gta =
      newEmergencyList.length +
      newEssentialList.length +
      newNonEssentialList.length +
      newGridTiedNotAllowIslandingList.length +
      1;
    let newGridTiedAllowIslandingList = [
      ...loadList.gridTiedAllowIslandingList,
    ];
    newGridTiedAllowIslandingList.forEach(
      (newGridTiedAllowIslandingListData, index) => {
        newGridTiedAllowIslandingList[
          index
        ].attributes[0].loadPriority.attributeValue = gta;
        gta = gta + 1;
      }
    );
    setLoadList((prevState) => ({
      ...prevState,
      emergencyList: newEmergencyList,
      essentialList: newEssentialList,
      nonEssentialList: newNonEssentialList,
      gridTiedNotAllowIslandingList: newGridTiedNotAllowIslandingList,
      gridTiedAllowIslandingList: newGridTiedAllowIslandingList,
    }));
  };

  const onUpdate = (update) => setUpdate(update);

  const onChange = (values) => {
    setValues(values);
    if (currentProject?.isEnergyReserveSelectd) {
      setBESS((prevState) => ({
        ...prevState,
        soc_emergency: values[2],
        soc_essential: values[3],
        //  soc_hysteresis: values[3],
        soc_nominal_power: values[4],
      }));

    } else {
      setBESS((prevState) => ({
        ...prevState,
        soc_emergency: values[1],
        soc_essential: values[2],
        //  soc_hysteresis: values[3],
        soc_nominal_power: values[3],
      }));
    }

  };

  const handleChangeBESS = (e) => {
    const { name, value } = e.target;
    const onlyNumberInt = /^[0-9]?\d*$/;
    let dataValue = "";
    if (onlyNumberInt.test(value)) {
      dataValue = value;
    } else {
      dataValue = BESS[name];
    }
    if (e.target.name === "powerReserve") {
      calulateAndSetpowerReservePercentageBESS(dataValue);
    }

    let newBESS = Object.assign({}, BESS);
    newBESS[name] = dataValue;

    if (
      name === "soc_emergency" ||
      name === "soc_essential" ||
      name === "soc_nominal_power"
    ) {
      newBESS[name] = dataValue === "" ? 0 : dataValue;
      calculateLoadSliderDisplayValues(newBESS);
    }
    setBESS(newBESS);
  };

  const calulateAndSetpowerReservePercentageBESS = (value) => {
    let reservePercentage = (
      (parseFloat(value) / parseFloat(BESS.max_power)) *
      100
    ).toFixed(2);
    setPowerReservePercentageBESS(
      reservePercentage >= 0 ? Math.round(Number(reservePercentage)) : 0
    );

    if (BESS.max_power === "") {
      callSnackbar("error", "BESS max power is not configured in SLD");
    }
  };

  const handleChangeGenset = (e) => {
    const { name, value } = e.target;
    const onlyNumberInt = /^[0-9]?\d*$/;
    let dataValue = "";
    if (onlyNumberInt.test(value)) {
      dataValue = value;
    } else {
      dataValue = genset[name];
    }
    let newGenset = Object.assign({}, genset);
    newGenset[e.target.name] = dataValue;
    if (name === "powerReserve") {
      calulateAndSetpowerReservePercentageGenset(dataValue);
    }

    setGenset(newGenset);
  };

  const calulateAndSetpowerReservePercentageGenset = (value) => {
    let reservePercentage = (
      (parseFloat(value) / parseFloat(genset.max_power)) *
      100
    ).toFixed(2);
    setPowerReservePercentageGenset(
      reservePercentage >= 0 ? Math.round(Number(reservePercentage)) : 0
    );

    if (genset.max_power === "") {
      callSnackbar("error", "Genset max power is not configured in SLD");
    }
  };

  const handleChangePowerReservePercentage = (e) => {
    const { value, name } = e.target;
    const onlyNumberInt = /^[0-9]?\d*$/;
    let dataValue = "";
    if (onlyNumberInt.test(value)) {
      dataValue = value;
    } else {
      if (name === "powerReservePercentageBESS") {
        dataValue = powerReservePercentageBESS;
      } else if (name === "powerReservePercentageGenset") {
        dataValue = powerReservePercentageGenset;
      }
    }
    if (name === "powerReservePercentageBESS") {
      setPowerReservePercentageBESS(dataValue);
    } else if (name === "powerReservePercentageGenset") {
      setPowerReservePercentageGenset(dataValue);
    }
    if (name === "powerReservePercentageBESS") {
      let reservePower = Math.round(
        parseFloat(BESS.max_power / 100) * parseFloat(dataValue)
      );
      if (BESS.max_power === "") {
        callSnackbar("error", "BESS max power is not configured in SLD");
      }
      setBESS((prevState) => ({
        ...prevState,
        powerReserve: reservePower >= 0 ? reservePower : 0,
      }));
    } else if (name === "powerReservePercentageGenset") {
      let reservePower = Math.round(
        parseFloat(genset.max_power / 100) * parseFloat(dataValue)
      );
      if (genset.max_power === "") {
        callSnackbar("error", "Genset max power is not configured in SLD");
      }
      setGenset((prevState) => ({
        ...prevState,
        powerReserve: reservePower >= 0 ? reservePower : 0,
      }));
    }
  };

  const handleRadioButtonChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "gridOutrageDetectionCase":
        setGridDetails((prevState) => ({
          ...prevState,
          gridOutrageDetectionCase: value,
        }));
        break;

      case "gensetBackfeedProtectionStatus":
        setGensetDetails((prevState) => ({
          ...prevState,
          gensetBackfeedProtectionStatus: value,
        }));
        break;

      case "BESSChargingEnabled":
        setBESSChargingEnabled(value);
        break;

      case "BESSHibernateEnabled":
        setBESSHibernateEnabled(value);
        break;

      default:
        break;
    }
  };

  const handleGensetOptimizationConfirm = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      gensetOptimisationConfirmPopUpStatus: true,
    }));

  const confirmGensetOptimisation = () => {
    setGensetDetails((prevState) => ({
      ...prevState,
      gensetBackfeedProtectionStatus: "Y",
    }));
    setPopupStatus((prevState) => ({
      ...prevState,
      gensetOptimisationConfirmPopUpStatus: false,
    }));
  };

  const cancelGensetOptimisation = () => {
    setPopupStatus((prevState) => ({
      ...prevState,
      gensetOptimisationConfirmPopUpStatus: false,
    }));
  };

  const openBessChargingpopup = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      bessChargingConfirmPopUpStatus: true,
    }));

  const confirmBessCharging = () => {
    setBESSChargingEnabled("Y");
    setPopupStatus((prevState) => ({
      ...prevState,
      bessChargingConfirmPopUpStatus: false,
    }));
  };

  const cancelBessCharging = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      bessChargingConfirmPopUpStatus: false,
    }));

  const openBessHibernatepopup = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      besshibernateConfirmPopUpStatus: true,
    }));

  const confirmBessHibernate = () => {
    setBESSHibernateEnabled("Y");
    setPopupStatus((prevState) => ({
      ...prevState,
      besshibernateConfirmPopUpStatus: false,
    }));
  };

  const cancelBessHibernate = () =>
    setPopupStatus((prevState) => ({
      ...prevState,
      besshibernateConfirmPopUpStatus: false,
    }));

  //* Optmization Engine

  const autogridDetailsHandler = (autogridOptimization) => {
    setAutogridOptimization(autogridOptimization);
    configuredStatusModified("autogridConfiguredStatus");
  };

  //* general
  const configuredStatusNot = (data) =>
    setConfiguredStatus((prevState) => ({ ...prevState, [data]: 0 }));

  const configuredStatusModified = (data) => {
    sessionStorage.setItem("programDataModified", true);
    setConfiguredStatus((prevState) => ({ ...prevState, [data]: 2 }));
  };
  const configuredAll = () => {
    setConfiguredStatus((prevState) => ({
      ...prevState,
      dcConfiguredStatus: 1,
      dynamicConfiguredStatus: 1,
      bessOperatingModes: 1,
      realTimeControlEMA: 1,
      sellTariffConfiguration: 1,
      sellTariffConfiguredStatus: 1,
      emConfiguredStatus: 1,
      scConfiguredStatus: 1,
      lsConfiguredStatus: 1,
      tmConfiguredStatus: 1,
      gofpConfiguredStatus: 1,
      bclConfiguredStatus: 1,
      bhConfiguredStatus: 1,
      configuredBlocks: 1,
      autogridConfiguredStatus: 1,
      exportManagementStatus:1,
      dcThresholdStatus:1,
      bessOperatingModeStatus:1,
      importManagementStatus: 1,
      exportManagementStatus1: 1,
    }));
  };

  //* valid optimization autogrid

  const setAutogridOptimizationDetails = (response) => {
    if(!response){
      return;
    }
    setOptimizationServer(response?.optimizationServer);
    if (response?.serverData?.resources[0]?.id !== "") {
      setAutogridOptimization(response?.serverData);
    } else {
      getExternalID(response?.serverData);
    }
  };

  const validAutogridOptimization = () => {
    if (
      gridSettings.remoteMonitoringControl &&
      clientType === embLabels.GREENSTRUXURE_PROJECT &&
      optimizationServer.optimizationType === "AUTOGRID"
    ) {
      const IDs = autogridOptimization.resources
        .filter((resource) => resource.enabled)
        .map((resource) => resource.id)
        .concat(autogridOptimization.servicePoint);

      if (IDs.includes("")) {
        return [true, "AutoGrid configuration is missing a mandatory Id"];
      } else if (new Set(IDs).size !== IDs.length) {
        return [
          true,
          "AutoGrid configuration uses a single Id for multiple objects",
        ];
      } else {
        return [false, ""];
      }
    } else {
      return [false, ""];
    }
  };

  const validateSystemsPage = (systemsPage) => {
    let jsonBody = {
      projectId: projectId,
      systemsPage,
    };

    // setLoading(true);
    apiSession
      .validateSystemSettings(jsonBody)
      .then(() => {
        if (clientType === "A2E_PROJECT") {
          setCurrentProject((prevData) => ({
            ...prevData,
            showSystems: true,
            showBOM: true,
            showDeploy: true,
          }));
        }
        // setLoading(false);
        // document.getElementById("dialog-communication-validation").open = true;
        // callSnackbar(`success`, `Communication validation status`);
      })
      .catch((error) => {
       
          if (error?.response?.status === 400) {
            callSnackbar(`error`, `${error?.response?.data?.message}`);
          } else {
          callSnackbar("error", "Duplicate values found");
        }
        sessionStorage.setItem("communicationValidated", true);
        // setLoading(false);
      });
  };

  const onValidateCommunicationSetting = () => {
    const cbTypes = ["Circuit Breaker"];
    const derTypes = [
      "Utility",
      "Genset",
      "BESS",
      "Inverter",
      "CHP",
      "EV_charging_station",
    ];

    const CBIP = systemState.systemInfoDER
      .filter((data) => cbTypes.includes(data.network) && data.ipAddress)
      .map((data) => ({
        firstOctet: data.ipAddress.split(".")[0],
        secondOctet: data.ipAddress.split(".")[1],
        thirdOctet: data.ipAddress.split(".")[2],
        fourthOctet: data.ipAddress.split(".")[3],
      }));

    const CBMASK = systemState.systemInfoDER
      .filter((data) => cbTypes.includes(data.network) && data.mask)
      .map((data) => ({
        firstOctet: data.mask.split(".")[0],
        secondOctet: data.mask.split(".")[1],
        thirdOctet: data.mask.split(".")[2],
        fourthOctet: data.mask.split(".")[3],
      }));

    const DERIP = systemState.systemInfoDER
      .filter((data) => derTypes.includes(data.network) && data.ipAddress)
      .map((data) => ({
        firstOctet: data.ipAddress.split(".")[0],
        secondOctet: data.ipAddress.split(".")[1],
        thirdOctet: data.ipAddress.split(".")[2],
        fourthOctet: data.ipAddress.split(".")[3],
      }));

    const DERMASK = systemState.systemInfoDER
      .filter((data) => derTypes.includes(data.network) && data.mask)
      .map((data) => ({
        firstOctet: data.mask.split(".")[0],
        secondOctet: data.mask.split(".")[1],
        thirdOctet: data.mask.split(".")[2],
        fourthOctet: data.mask.split(".")[3],
      }));

    const SYSTEMIP = systemState.systemCommunication
      .filter((data) => data.ipAddress)
      .map((data) => ({
        firstOctet: data.ipAddress.split(".")[0],
        secondOctet: data.ipAddress.split(".")[1],
        thirdOctet: data.ipAddress.split(".")[2],
        fourthOctet: data.ipAddress.split(".")[3],
      }));

    const SYSTEMMASK = systemState.systemCommunication
      .filter((data) => data.mask)
      .map((data) => ({
        firstOctet: data.mask.split(".")[0],
        secondOctet: data.mask.split(".")[1],
        thirdOctet: data.mask.split(".")[2],
        fourthOctet: data.mask.split(".")[3],
      }));

    const ALLIP = [...CBIP, ...DERIP, ...SYSTEMIP];
    const ALLMASK = [...CBMASK, ...DERMASK, ...SYSTEMMASK];

    const ALL_THIRDOCTET_IPSAME = ALLIP.every(
      (value) => value["thirdOctet"] === ALLIP[0]["thirdOctet"]
    );

    //devices are in same IP range
    const SAME_IPRANGE = ALLMASK.every(
      (value) =>
        value["firstOctet"] === "255" &&
        value["secondOctet"] === "255" &&
        value["thirdOctet"] === "255" &&
        value["fourthOctet"] >= "0" &&
        value["fourthOctet"] <= "255"
    );

    //devices are in diff IP range
    const DIFF_IPRANGE = ALLMASK.every(
      (value) =>
        value["firstOctet"] === "255" &&
        value["secondOctet"] === "255" &&
        value["thirdOctet"] >= "0" &&
        value["thirdOctet"] <= "255" &&
        value["fourthOctet"] >= "0" &&
        value["fourthOctet"] <= "255"
    );

    if (ALL_THIRDOCTET_IPSAME) {
      if (SAME_IPRANGE) {
        sessionStorage.setItem("communicationValidated", false);
        validateSystemsPage(false);
      } else {
        sessionStorage.setItem("communicationValidated", true);
        callSnackbar("error", 'Update mask values to "255.255.255.X"');
      }
    } else {
      if (DIFF_IPRANGE) {
        sessionStorage.setItem("communicationValidated", false);
        validateSystemsPage(false);
      } else {
        sessionStorage.setItem("communicationValidated", true);
        callSnackbar("error", 'Update mask values to "255.255.X.Y"');
      }
    }
  };

  const validResultFunc = (result) => {
    validateProgram(result);
  };

  const validResultFuncProgram = async () => {
    if (gridSettings.demandCharge || gridSettings.tariffManagement) {
      try {
        const tariffAccordions = document.querySelectorAll(
          "[data-test-id=tariff-data]"
        );
        const parentAccordionStatus = (index) =>
          tariffAccordions[index]?.parentElement?.parentElement?.parentNode
            ?.classList?.[0];

        // Expand demand charge accordions before triggering calendar validation.
        if (parentAccordionStatus(0) === "accordionClose") {
          tariffAccordions[0]?.click();
          tariffAccordions[1]?.click();
        } else if (
          parentAccordionStatus(0) === "accordionOpen" &&
          parentAccordionStatus(1) === "accordionClose"
        ) {
          tariffAccordions[1]?.click();
        }

        // CalendarTariff listens to lastSubmit and invokes validResult callback.
        setRefresh((prevRefresh) => prevRefresh + 1);
        if(projectTypeValue === "NMGaaS ETO EMOL" || projectTypeValue ===  "NMGaaS ETO" ){
           validateProgram(true);
        }
       
      } catch (error) {
        console.log("Error while opening tariff accordion", error);
        callSnackbar(
          "error",
          "Unable to validate tariff configuration. Please retry."
        );
      }
    } else {
      validateProgram(true);
    }
  };
  const isDcThresholdCustomValueNonEmpty = () => {
    const updatedErrors = {};
    let isCustomValueNonEmpty = false;
    dcthreshold?.customValues?.forEach((element, index) => {
      if (element.billingPeriodPreset === "" || element.billingPeriodPreset === 0) {
        isCustomValueNonEmpty = true;
        updatedErrors[`${index}-${"billingPeriodPreset"}`] = "This field is required";
      }
      if (element.peakPreset === "" || element.peakPreset === 0) {
        isCustomValueNonEmpty = true;
        updatedErrors[`${index}-${"peakPreset"}`] = "This field is required";
      }
      setDcthresholdCustomMonthErrors(updatedErrors);
    });

    return isCustomValueNonEmpty;
  }
  const openDcThresholdAccordion = async () => {
    if (document.querySelectorAll("[data-test-id=tariff-data]")[0]
      ?.parentElement?.parentElement?.parentNode?.classList?.[0] ===
      "accordionClose"
    ) {
      await new Promise((resolve) => {
        document
          .querySelectorAll("[data-test-id=dc-threshold]")[0]
          .addEventListener("click", resolve, { once: true });
        document.querySelectorAll("[data-test-id=dc-threshold]")[0]?.click();
      });
      await new Promise((resolve) => {
        document.querySelectorAll("[data-test-id=tariff-data]")[3]
          .addEventListener("click", resolve, { once: true });
        document.querySelectorAll("[data-test-id=tariff-data]")[3]?.click();
      });
    } else if (document.querySelectorAll("[data-test-id=tariff-data]")[0]
      ?.parentElement?.parentElement?.parentNode?.classList?.[0] ===
      "accordionOpen") {
      await new Promise((resolve) => {
        document
          .querySelectorAll("[data-test-id=tariff-data]")[3]
          .addEventListener("click", resolve, { once: true });
        document.querySelectorAll("[data-test-id=tariff-data]")[3]?.click();
      });

    }

  }
  const validateProgram = (result) => {
    const [autogridOptError, autogridOptErrorMsg] = validAutogridOptimization();
    const showLoadManagement = projectTypeValue === "NMGaaS ETO"
    ? gridSettings?.loadManagement === true
    : (gridSettings?.exportOptimization === true && siteType === embLabels.GRID_CONNECTED) ||
    siteType === embLabels.ISLANDABLE ||
    siteType === embLabels.OFF_GRID;

    if (loadShedding.loadShedding === true) {
      const runEffectsNew = { loadPriority: true };
      setRunEffects(runEffectsNew);
    }
    const loadsCheck = loads?.filter(
      (load) => load.attributes[0].motorized.attributeValue !== "0"
    );

    /* validate Demand Charge Data  start*/
    if (
      (gridSettings?.demandCharge || gridSettings?.tariffManagement) &&
      (result === undefined || result === null)
    ) {
      return null;
    }
    if (siteGroup === "") {
      callSnackbar("error", "Site Group is mandatory");
    } else if (
      ["BASIC_ALARM"].includes(selectedAlaram) &&
      emailUsers.length === 0
    ) {
      const newSelectedName =
        selectedAlaram === "BASIC_ALARM" ? "Basic alarm" : "Advanced alarm";

      callSnackbar(
        "error",
        `${newSelectedName} usecase requires minimum one email address`
      );
    } else if (autogridOptError) {
      callSnackbar("error", `${autogridOptErrorMsg}`);
    } else if (
      gridSettings?.bessEnergyExchanges === true &&
      [""].includes(isBessOperatingMode)
    ) {
      callSnackbar("error", "Require minimum one Bess Operating Mode");
    }else if (
      gridSettings?.exportOptimization === true &&
      limitImport === true &&
      (
        limitImportExport?.maxLimitEnergyImportPower === "")
    ) {
      callSnackbar(
        "error",
        " Limit Energy Import/Export   - Targeted Max Import power is mandatory"
      );
    }
     else if (
      gridSettings?.exportOptimization === true &&
      limitImport === true &&
      (!limitImportExport?.maxLimitEnergyImportPower ||
        Number(limitImportExport?.maxLimitEnergyImportPower) <= 0)
    ) {
      callSnackbar(
        "error",
        " Limit Energy Import/Export   - Targeted Max Import power is mandatory  and should be greater than 0"
      );
    } else if (
      gridSettings?.exportOptimization === true &&
      limitImport === true &&
      limitImportExport?.minLimitEnergyImportPower === ""
    ) {
      callSnackbar(
        "error",
        "Import Management   - Targeted Min Import power is mandatory"
      );
    }
    else if (
      gridSettings?.exportOptimization === true &&
      limitExport === true &&
      limitImportExport?.maxLimitEnergyExportPower === ""
    ) {
      callSnackbar(
        "error",
        "Export Management   - Targeted Max Export power is mandatory "
      );
    } else if (
      gridSettings?.exportOptimization === true &&
      limitExport === true &&
      limitImportExport?.minLimitEnergyExportPower === ""
    ) {
      callSnackbar(
        "error",
         "Real Time Export Control    - Targeted Max Export power is mandatory "
      );
    }
    else if (gridSettings?.noExport === true && maxExportPower === "") {
      callSnackbar(
        "error",
        "Export Management   - Targeted Min PCC power is mandatory "
      );
    } else if (
      gridSettings?.noImport === true &&
      (importStopHysteresis === "" ||
        importStartHysteresis === "" ||
        parseInt(importStopHysteresis) <= parseInt(importStartHysteresis))
    ) {
      if (importStopHysteresis === "") {
        callSnackbar(
          "error",
          " Real Time Import Control   - Targeted Max Stop Hysteresis  is mandatory & Range ( 0 <= Stop Hysteresis <= 1000)"
        );
      } else if (
        gridSettings?.noImport === true &&
        parseInt(importStopHysteresis) <= parseInt(importStartHysteresis)
      ) {
        callSnackbar(
          "error",
          "Real Time Import Control  - Targeted Import Stop Hysteresis it should be greater than Import Start Hysteresis"
        );
      }
    } else if (sellTariff === "likeBuy" && deltaSellTariff === "") {
      callSnackbar("error", "Delta Sell Tariff- value is mandatory");
    } else if (
      BESS.soc_emergency.toString() === "" ||
      parseInt(BESS.soc_emergency) > 100
    ) {
      callSnackbar(
        "error",
        "Load shedding - SoC Emergency is mandatory & should be less than 100"
      );
    } else if (
      BESS.soc_essential.toString() === "" ||
      parseInt(BESS.soc_essential) > 100
    ) {
      callSnackbar(
        "error",
        "Load shedding - SoC Essential is mandatory & should be less than 100"
      );
    } else if ( projectTypeValue !== "NMGaaS ETO" && loadShedding.loadShedding === true && loadsCheck.length !== 0) {
      callSnackbar("error", "Load shedding - Loads are not prioritized");
    } else if (projectTypeValue !== "NMGaaS ETO" && (loadShedding.loadSheddingGridtiedStatus === "Y" || loadShedding.loadSheddingStatus === "Y"  )&& loadsCheck.length !== 0) {
      callSnackbar("error", "Load shedding - Loads are not prioritized");
    } else if(showLoadManagement && loadShedding.loadShedding === true && loadsCheck.length !== 0){
        callSnackbar("error", "Load shedding - Loads are not prioritized");
    }
    else if (
      loadShedding.loadShedding === true &&
      reconnectionTimers.reconnectionTimer.toString() === ""
    ) {
      callSnackbar(
        "error",
        "Load shedding - Delay before reconnecting a load after last shedding (s) is mandatory"
      );
    } else if (
      loadShedding.loadShedding === true &&
      (parseInt(reconnectionTimers.reconnectionTimer) <
        defaultsMinMax.delayReconnectingMin ||
        parseInt(reconnectionTimers.reconnectionTimer) >
        defaultsMinMax.delayReconnectingMax)
    ) {
      callSnackbar(
        `error`,
        `Load shedding - Delay before reconnecting a load after last shedding  should be in range (${defaultsMinMax.delayReconnectingMin}-${defaultsMinMax.delayReconnectingMax} s`
      );
    } else if (
      loadShedding.loadShedding === true &&
      reconnectionTimers.reconnection2Timer.toString() === ""
    ) {
      callSnackbar(
        "error",
        "Load shedding - Delay before reconnecting a load after last load reconnection (s) is mandatory and between 0-600s"
      );
    } else if (
      loadShedding.loadShedding === true &&
      (parseInt(reconnectionTimers.reconnection2Timer) <
        defaultsMinMax.delayReconnecting2Min ||
        parseInt(reconnectionTimers.reconnection2Timer) >
        defaultsMinMax.delayReconnecting2Max)
    ) {
      callSnackbar(
        "error",
        "Load shedding - Delay before reconnecting a load after last load reconnection should be in range (" +
        defaultsMinMax.delayReconnecting2Min +
        "-" +
        defaultsMinMax.delayReconnecting2Max +
        " s)"
      );
    } else if (
      loadShedding.loadShedding === true &&
      ((batteryDetails?.batteryBufferingStatus === true &&
        BESS.powerReserve.toString() === "") ||
        (parseFloat(BESS.powerReserve) / parseFloat(BESS.max_power)) * 100 > 50)
    ) {
      callSnackbar(
        "error",
        "Load shedding - BESS power reserve is mandatory & should not exceed more than 50% of max power"
      );
    } else if (
      loadShedding.loadShedding === true &&
      (siteType === embLabels.ISLANDABLE ||
        siteType === embLabels.ISLANDABLE_GSX) &&
      ((gensetDetails.gensetAvailabilityStatus === true &&
        genset.powerReserve.toString() === "") ||
        (parseFloat(genset.powerReserve) / parseFloat(genset.max_power)) * 100 >
        50)
    ) {
      callSnackbar(
        "error",
        "Load shedding - Genset power reserve is mandatory & should not exceed more than 50% of max power"
      );
    } else if (gridDetails?.lostDetectionTimer.toString() === "") {
      callSnackbar(
        "error",
        "Transition Management - Grid Lost Detection Timer is mandatory"
      );
    } else if (
      parseInt(gridDetails.lostDetectionTimer) <
      defaultsMinMax.gridLostTimerMin ||
      parseInt(gridDetails.lostDetectionTimer) > defaultsMinMax.gridLostTimerMax
    ) {
      callSnackbar(
        "error",
        "Transition Management - Grid Lost Detection Timer should be in range(" +
        defaultsMinMax.gridLostTimerMin +
        "-" +
        defaultsMinMax.gridLostTimerMax +
        " ms)"
      );
    } else if (gridDetails?.gridDetectionTimer.toString() === "") {
      callSnackbar(
        "error",
        "Transition Management - Good Grid Detection Timer is mandatory"
      );
    } else if (
      parseInt(gridDetails.gridDetectionTimer) <
      defaultsMinMax.goodGridDetectionTimerMin ||
      parseInt(gridDetails.gridDetectionTimer) >
      defaultsMinMax.goodGridDetectionTimerMax
    ) {
      callSnackbar(
        "error",
        "Transition Management - Good Grid Detection Timer should be in range(" +
        defaultsMinMax.goodGridDetectionTimerMin +
        "-" +
        defaultsMinMax.goodGridDetectionTimerMax +
        " s)"
      );
    } else if (
      gensetDetails.gensetBackfeedProtection === true &&
      (gensetLoad.toString() === "" ||
        parseInt(gensetLoad) === 0 ||
        (parseFloat(gensetLoad) / parseFloat(maxGensetLoad)) * 100 < 10.0 ||
        (parseFloat(gensetLoad) / parseFloat(maxGensetLoad)) * 100 > 100.0) &&
      (siteType === embLabels.ISLANDABLE ||
        siteType === embLabels.PV_HYBRIDIZATION ||
        siteType === embLabels.GENSET_PVBESS_A2E ||
        (siteType === embLabels.ISLANDABLE_GSX &&
          architectureType === embLabels.PV_GENSET_ATS))
    ) {
      callSnackbar(
        "error",
        "Genset Feedback Protection - Targeted Min Genset load is mandatory & should be in range  10% to 100% of Max Power"
      );
    }else if(isTMHSelected && eVceData?.evMaxAllowedPowerDM > evMaxAllowedPower){
      callSnackbar("error", " EV Max Allowed Power (kW) (Degraded Mode) should be less than or equal to EV Max Allowed Power (kW) (Nominal case)");
    } else if (
      isEVSelected &&
      ["MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue) &&
      eVceData.webServiceURL === ""
    ) {
      callSnackbar("error", "Webservice URL - Should not be empty");
    } else if (
      isEVSelected &&
      ["MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue) &&
      eVceData.noOfZones === ""
    ) {
      callSnackbar("error", "Number of Zones -Should not be empty");
    } else if (
      isEVSelected &&
      ["MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue) &&
      eVceData.componentIds === ""
    ) {
      callSnackbar("error", "Component ID -Should not be empty");
    } else if (
      isEVSelected &&
      ["MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue) &&
      eVceData.onPeakPowerLimit === ""
    ) {
      callSnackbar("error", "On Peak Power Limit (kW) - Should not be empty");
    } else if (
      isEVSelected &&
      ["MGaaS IEC", "MGaaS ETO"].includes(projectTypeValue) &&
      eVceData.offPeakPowerLimit === ""
    ) {
      callSnackbar("error", "OFF Peak Power Limit (kW) - Should not be empty");
    } else if (billingPeriod.billingType === "FIXED" && (Number(billingPeriod.fixDay) < 1 || Number(billingPeriod.fixDay) > 28)) {
      callSnackbar("error", "Please fill the mandatory details in Utility Billing Contract");
    }
    else if (
      demandChargeUseCaseSelection === "DCMP" &&
      dcthreshold.type !== "FIXED" &&
      (projectTypeValue === "MGaaS ANSI" || projectTypeValue === "DaaS ANSI") &&
      isDcThresholdCustomValueNonEmpty() === true
    ) {
      callSnackbar(
        "error",
        "Billing Period Preset and Peak Preset for DC Threshold - Should not be empty"
      );
      openDcThresholdAccordion();
    } else if (
      demandChargeUseCaseSelection === "DCMP" &&
      dcthreshold.type === "FIXED" &&
      (projectTypeValue === "MGaaS ANSI" || projectTypeValue === "DaaS ANSI") &&
      (dcthreshold?.fixedValues?.peakPreset === "" ||
        dcthreshold?.fixedValues?.billingPeriodPreset === "" ||
        (dcthreshold?.valueType === "VALUE" && Number(dcthreshold?.fixedValues?.peakPreset) < 0) ||
        (dcthreshold?.valueType === "VALUE" && Number(dcthreshold?.fixedValues?.peakPreset) > 999) ||
        (dcthreshold?.valueType === "VALUE" && Number(dcthreshold?.fixedValues?.billingPeriodPreset) > 999) ||
        (dcthreshold?.valueType === "VALUE" && Number(dcthreshold?.fixedValues?.billingPeriodPreset) < 0))
    ) {
      callSnackbar(
        "error",
        "Billing Period Preset and Peak Preset for DC Threshold - Should not be empty"
      );
    }else if(!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(projectTypeValue ) && Number(limitImportExport?.maxLimitEnergyImportPower?.toString()) > Number(derMaxPowerMap?.Utility)){
      callSnackbar(
        "error",
        `Maximum Import Power Limit (kW) should be less than Utility (${derMaxPowerMap?.Utility}) breaker limit`
      );
    } else if (!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(projectTypeValue ) &&
      limitImportExport?.exportType === "Custom Export" &&
      limitImportExport?.maxLimitEnergyExportPower?.toString() !== "" &&
      (Number(limitImportExport?.maxLimitEnergyExportPower?.toString()) < -Number(derMaxPowerMap?.Utility) ||
        Number(limitImportExport?.maxLimitEnergyExportPower?.toString()) > Number(limitImportExport?.maxLimitEnergyImportPower?.toString()))
    ) {
      callSnackbar(
        "error",
        `Minimum PCC Power Limit (kW) should be greater than(-${derMaxPowerMap?.Utility}) breaker limit and less than or equal to (${limitImportExport?.maxLimitEnergyImportPower})`
      );
    }else if(!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(projectTypeValue)  && limitImportExport?.maxLimitEnergyImportPower === ""){
      callSnackbar(
        "error",
        `Maximum Import Power Limit (kW) is required`
      );
    }else if(!["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes(projectTypeValue)  && limitImportExport?.maxLimitEnergyExportPower === ""){
      callSnackbar(
        "error",
        `Minimum PCC Power Limit (kW) is required`
      );
    } 
     else {
      setLoading(true);
      let resources = [];
      let resourcesLoad = [];
      let resourcesEm = [];
      let resourcesEs = [];
      let resourcesNEs = [];
      let resourceGAI = [];
      let resourceGANI = [];

      let i = 1;
      if(!loadList) return;
      let newEmergencyList = [...loadList.emergencyList];
      if(!newEmergencyList) return;
      newEmergencyList?.forEach((newEmergencyListData, index) => {
        newEmergencyList[index].attributes[0].loadPriority.attributeValue = i;
        i = i + 1;
      });

      let ies = newEmergencyList?.length + 1;
      let newEssentialList = [...loadList.essentialList];
      newEssentialList.forEach((newEssentialListData, index) => {
        newEssentialList[index].attributes[0].loadPriority.attributeValue = ies;
        ies = ies + 1;
      });

      let ine = newEmergencyList.length + newEssentialList.length + 1;
      let newNonEssentialList = [...loadList.nonEssentialList];
      newNonEssentialList?.forEach((newNonEssentialListData, index) => {
        newNonEssentialList[index].attributes[0].loadPriority.attributeValue =
          ine;
        ine = ine + 1;
      });

      let gtna =
        newEmergencyList.length +
        newEssentialList.length +
        newNonEssentialList?.length +
        1;
      let newGridTiedNotAllowIslandingList = [
        ...loadList.gridTiedNotAllowIslandingList,
      ];
      newGridTiedNotAllowIslandingList?.forEach(
        (newGridTiedNotAllowIslandingListData, index) => {
          newGridTiedNotAllowIslandingList[
            index
          ].attributes[0].loadPriority.attributeValue = gtna;
          gtna = gtna + 1;
        }
      );

      let gta =
        newEmergencyList.length +
        newEssentialList.length +
        newNonEssentialList.length +
        newGridTiedNotAllowIslandingList?.length +
        1;
      let newGridTiedAllowIslandingList = [
        ...loadList.gridTiedAllowIslandingList,
      ];
      newGridTiedAllowIslandingList?.forEach(
        (newGridTiedAllowIslandingListData, index) => {
          newGridTiedAllowIslandingList[
            index
          ].attributes[0].loadPriority.attributeValue = gta;
          gta = gta + 1;
        }
      );

      loads?.forEach((LData) => {
        resourcesLoad.push(LData);
      });
      newEmergencyList?.forEach((EMData) => {
        resourcesEm.push(EMData);
      });
      newEssentialList?.forEach((ESData) => {
        resourcesEs.push(ESData);
      });
      newNonEssentialList?.forEach((NESData) => {
        resourcesNEs.push(NESData);
      });
      newGridTiedAllowIslandingList?.forEach((GAIData) => {
        resourcesNEs.push(GAIData);
      });
      newGridTiedNotAllowIslandingList?.forEach((GANIData) => {
        resourcesNEs.push(GANIData);
      });
      resources.push(...resourcesLoad);
      resources.push(...resourcesEm);
      resources.push(...resourcesEs);
      resources.push(...resourcesNEs);
      resources.push(...resourceGAI);
      resources.push(...resourceGANI);

      let newBESS = Object.assign({}, BESS);
      newBESS.changed = 1;
      let newGenset = Object.assign({}, genset);
      newGenset.changed = 1;
      let newTariffDynamicConfiguration =
        tariffDynamicConfiguration === null
          ? null
          : { ...tariffDynamicConfiguration };
      if (newTariffDynamicConfiguration === "null") {
        newTariffDynamicConfiguration = null;
      } else if (newTariffDynamicConfiguration?.tariffType === "dynamic") {
        delete newTariffDynamicConfiguration?.spotPriceTariff;
      } else {
        delete newTariffDynamicConfiguration?.dynamicHourTariff;
      }

      if (
        gridSettings?.demandCharge === false &&
        gridSettings?.tariffManagement === false
      ) {
        setTariffDynamicConfiguration(null);
        setSellTariff(null);
        setDeltaSellTariff(null);
      }

      let programDataJson = {
        projectId: projectId,
        siteGroup: siteGroup,
        gridDetectionTimer: gridDetails?.gridDetectionTimer,
        lostDetectionTimer: gridDetails?.lostDetectionTimer,
        gridOutrageDetection:
          gridDetails?.gridOutrageDetectionCase === "CB" ? 1 : 2,
        pvCurtailment: pvCurtailment,
        pvBreakers: pvBreakers,
        batteryBuffering: batteryDetails?.batteryBuffering,
        uc_dc: false,
        uc_tm: false,
        uc_sc: false,
        uc_no_export: false,
        exportManagement: exportManagement,
        gensetBackfeedProtection:
          gensetDetails.gensetBackfeedProtectionStatus === "Y" ? true : false,
        gensetLSIEnable: gensetLSIEnable,
        loadShedding: loadShedding.loadShedding,
        loadSheddingActivatedGridTied: loadShedding.loadSheddingGridtiedStatus === "N" ? false : loadShedding.loadSheddingActivatedGridTied,
        utilityLSIEnable: utilityLSIEnable,
        gensetLoad: gensetLoad,
        maxExportPower: maxExportPower,
        // importStartHysteresis: importStartHysteresis,
        // importStopHysteresis: Number(importStopHysteresis),
        maxLimitEnergyExportPower: Number(limitImportExport?.maxLimitEnergyExportPower),
        minLimitEnergyExportPower: Number(limitImportExport?.minLimitEnergyExportPower),
        maxLimitEnergyImportPower: Number(limitImportExport?.maxLimitEnergyImportPower),
        minLimitEnergyImportPower: Number(limitImportExport?.minLimitEnergyImportPower),
        bessImport: limitImportExport?.bessImport,
         bessExport: limitImportExport?.bessExport,
        pvExport: limitImportExport?.pvExport,
        importType: limitImportExport?.importType,
        exportType: limitImportExport?.exportType,
        limitExport: limitExport,
        limitImport: limitImport,
        meteringPriority: derPriority,
        resetLoads: false,
        pvCurtailmentExport: pvCurtailmentExport,
        lossOfComm: lossOfComm,
        portableGensetMethod: isPortableGensetSelection,
        portableGenset: isPortableGenset,
        bessOperatingModes: isBessOperatingMode,
        batteryBufferingExport: batteryDetails?.batteryBufferingExport,
        BESS: batteryDetails?.batteryBufferingStatus === true ? newBESS : null,
        Genset: newGenset,
        reconnectionTimer: reconnectionTimers.reconnectionTimer,
        reconnection2Timer: reconnectionTimers.reconnection2Timer,
        loadPercentage:
          parseInt(gensetLoad) > 0
            ? (
              (parseFloat(gensetLoad) / parseFloat(maxGensetLoad)) *
              100
            ).toFixed(2)
            : 0.0,
        resources: resources,

        demandCharge: JSON.stringify(demandChargeData),
        tariffDynamicConfiguration:
          newTariffDynamicConfiguration === null
            ? null
            : JSON.stringify(newTariffDynamicConfiguration),
        sellTariff: sellTariff,
        deltaSellTariff: deltaSellTariff,
        programPage: false,
        bessHibernatingActivated: BESSHibernateEnabled === "Y" ? true : false,
        alarm: {
          alarmType: gridSettings?.remoteMonitoringControl
            ? selectedAlaram
            : "NO_ALARM",
          amsService: amsService,
          emails:
            selectedAlaram === "NO_ALARM" ||
              !gridSettings.remoteMonitoringControl
              ? []
              : emailUsers,
        },
      };
       if(["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes( projectKind?.projectTypeValue || projectTypeValue)){
        // programDataJson.exportType = "";
        // programDataJson.importType = "";
      programDataJson.maxExportPower = limitExport === true?maxExportPower:0;
      programDataJson.maxLimitEnergyExportPower=limitExport === true? Number(maxExportPower):0;
      programDataJson.maxLimitEnergyImportPower = limitImport === true? Number(limitImportExport?.maxLimitEnergyImportPower):0;
    }
      if(projectKind?.projectTypeValue !== "NMGaaS ETO" || projectTypeValue !== "NMGaaS ETO" || projectTypeData !== "NMGaaS ETO"){
        programDataJson.peakStartImportHysteresis = peakImportHysteresis?.startHysteresisPercent === "" ? "0": peakImportHysteresis?.startHysteresisPercent
        programDataJson.peakStopImportHysteresis = peakImportHysteresis?.stopHysteresisPercent === ""? "0": peakImportHysteresis?.stopHysteresisPercent
      }
      if (demandChargeUseCaseSelection === "DCMP" && dcthreshold) {
        let dcthresholdJson = { ...dcthreshold };
        if (dcthresholdJson.type === "FIXED") {
          dcthresholdJson.customValues = null;
        } else {
          dcthresholdJson.fixedValues = null;
        }
        programDataJson.dcThreshold = JSON.stringify(dcthresholdJson);
      }
      if (billingPeriod) {
        let billingPeriodJson = { ...billingPeriod };
        if (billingPeriodJson.billingType === "CUSTOM") {
          billingPeriodJson.fixDay = null;
        } else {
          billingPeriodJson.customDays = null;
        }
        
        programDataJson.billingPeriod = siteType ==="OFF_GRID"?null:JSON.stringify(billingPeriodJson);
      }
      if (
        loadList?.gridTiedNotAllowIslandingList.length > 0 ||
        loadList?.gridTiedAllowIslandingList.length > 0
      ) {
        programDataJson.gridTiedLoadsSheddable = Number(gridTiedLoadsSheddable);
      } else {
        programDataJson.gridTiedLoadsSheddable = 0;
      }
      if (!derPriority) {
        delete programDataJson.meteringPriority;
      }
      // if (limitImport === false || limitImport === null) {
      //   programDataJson.maxLimitEnergyImportPower = 0;
      // }
      // if (limitExport === false || limitExport === null) {
      //   programDataJson.maxLimitEnergyExportPower = 0;
      // }
      if (
        gridSettings?.demandCharge === false &&
        gridSettings?.tariffManagement === false
      ) {
        programDataJson.tariffDynamicConfiguration = null;
        programDataJson.sellTariff = null;
        programDataJson.deltaSellTariff = null;
      }
      if (sellTariff === "at0") {
        programDataJson.deltaSellTariff = null;
      }
      if (
        gridSettings?.demandCharge === true ||
        gridSettings?.tariffManagement === true
      ) {
        programDataJson.demandCharge = JSON.stringify(demandChargeOutput);
      } else {
        programDataJson.demandCharge = null;
      }

      if (
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        optimizationServer.optimizationType === "AUTOGRID"
      ) {
        programDataJson.serverData = autogridOptimization;
      } else {
        programDataJson.serverData = null;
      }

      if (batteryDetails?.batteryBufferingStatus === true) {
        let BESSChargingNew = Object.assign({}, BESSCharging);

        // BESSChargingNew.BESS_charging_limitation_enabled =
        //   BESSChargingEnabled === "Y" ? true : false;
        // BESSChargingNew.BESS_PV_limitation_enable =
        //   BESSChargingEnabled === "Y" ? true : false;
        // BESSChargingNew.BESS_PV_disconnection =
        //   BESSChargingEnabled === "Y" ? true : false;
        // setBESSCharging(BESSChargingNew);
        programDataJson.bessChargingLimitation =
          JSON.stringify(BESSChargingNew);
      } else {
        programDataJson.bessChargingLimitation = null;
      }
      if(isTMHSelected ===true){
        const tmhEvceJson = eVceData;
        programDataJson.tmhEvceJson =JSON.stringify( {
          ipAddress: tmhEvceJson.ipAddress,
          noOfZones: tmhEvceJson.noOfZones,
          evMaxAllowedPowerDM: tmhEvceJson.evMaxAllowedPowerDM,
          evMaxAllowedPowerNC: evMaxAllowedPower,
        });
        programDataJson.electricalVehicleEnergyMgmtJson = null;

      }else if (eVceData?.isElectricalVehicleEnergyManagement) {
        programDataJson.electricalVehicleEnergyMgmtJson = JSON.stringify(eVceData);
         programDataJson.tmhEvceJson = null;
      }
      if(limitImportExport?.exportType === "No Export"){
        programDataJson.maxLimitEnergyExportPower = 0;
        programDataJson.pvExport = false;
      }
      // if(limitImport === false){
       
      //   programDataJson.maxLimitEnergyImportPower =0;
      //   programDataJson.minLimitEnergyImportPower =0 ;
      //   programDataJson.bessImport =false;
           
      //  }
      //  if(limitExport === false){
      //  programDataJson.maxLimitEnergyExportPower = 0;
      //   programDataJson.minLimitEnergyExportPower = 0 ;
      //   programDataJson.bessExport = false;
      //   programDataJson.pvExport = false;
      //  }
      
      sessionStorage.setItem("optimizationModified", false);
      programDataJson.resetLoads = false;
      updateProgram(programDataJson);
    }
  };

  const updateProgram = (programData) => {
    apiSession
      .updateProgramData(programData)
      .then((response) => {
        assignLoads(response);
        setCurrentProject((prevData) => ({
          ...prevData,
          timeSettingsValidated: response?.systemsTimeSyncPage,
          secureArchitecturePage: response?.secureArchitecturePage,
          showSystems: !response?.programPage,
          showBOM:
            !response?.systemsPage && response?.secureArchitecturePage === true && response?.systemsTimeSyncPage === true,
          showDeploy:
            !response?.systemsPage && response?.secureArchitecturePage === true && response?.systemsTimeSyncPage === true,
        }));
        callSnackbar("success", "Program Validated Successfully");
        setLoading(false);
        sessionStorage.setItem("programDataModified", false);
        sessionStorage.setItem("programPage", false);
        configuredAll();

        if (clientType === "A2E_PROJECT") {
          onValidateCommunicationSetting();
        }
      })
      .catch(() => {
        callSnackbar("error", "Error in validation");
        setLoading(false);
      });
  };

  const validateDemandCharge = (data) => {
    // Iterate through each period in the periodsList
    for (const period of data.periodsList) {
      // Iterate through each dayGroup in the dayGroup array
      for (const dayGroup of period.dayGroup) {
        // Iterate through each tariff in the tariffList array
        for (const tariff of dayGroup.tariffList) {
          // Check if the timeSlot array is present and has elements
          if (tariff.timeSlot && tariff.timeSlot.length > 0) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const saveDraftGenerateProgram = (onDemand) => {
    if(!loadList) return;
    let resources = [];
    let resourcesLoad = [];
    let resourcesEm = [];
    let resourcesEs = [];
    let resourcesNEs = [];
    let resourcesGAI = [];
    let resourcesGANI = [];
    loads?.forEach((LData) => {
      resourcesLoad.push(LData);
    });
    loadList?.emergencyList?.forEach((EMData) => {
      resourcesEm.push(EMData);
    });
    loadList?.essentialList?.forEach((ESData) => {
      resourcesEs.push(ESData);
    });
    loadList?.nonEssentialList?.forEach((NESData) => {
      resourcesNEs.push(NESData);
    });
    loadList?.gridTiedAllowIslandingList?.forEach((GAIData) => {
      resourcesGAI.push(GAIData);
    });
    loadList?.gridTiedNotAllowIslandingList?.forEach((GANIData) => {
      resourcesGAI.push(GANIData);
    });

    resources.push(...resourcesLoad);
    resources.push(...resourcesEm);
    resources.push(...resourcesEs);
    resources.push(...resourcesNEs);
    resources.push(...resourcesGAI);
    resources.push(...resourcesGANI);
    let newBESS = Object.assign({}, BESS);
    newBESS.changed = 1;
    let newGenset = Object.assign({}, genset);
    newGenset.changed = 1;
    let newTariffDynamicConfiguration =
      tariffDynamicConfiguration === null
        ? null
        : { ...tariffDynamicConfiguration };
    if (newTariffDynamicConfiguration === "null") {
      newTariffDynamicConfiguration = null;
    } else if (newTariffDynamicConfiguration?.tariffType === "dynamic") {
      delete newTariffDynamicConfiguration?.spotPriceTariff;
    } else {
      delete newTariffDynamicConfiguration?.dynamicHourTariff;
    }
    if (
      gridSettings?.demandCharge === false &&
      gridSettings?.tariffManagement === false
    ) {
      setTariffDynamicConfiguration(null);
      setSellTariff(null);
      setDeltaSellTariff(null);
    }

    let programDataJson = {
      projectId: projectId,
      siteGroup: siteGroup,
      gridDetectionTimer: gridDetails?.gridDetectionTimer,
      lostDetectionTimer: gridDetails?.lostDetectionTimer,
      gridOutrageDetection:
        gridDetails?.gridOutrageDetectionCase === "CB" ? 1 : 2,
      pvCurtailment: pvCurtailment,
      pvBreakers: pvBreakers,
      batteryBuffering: batteryDetails?.batteryBuffering,
      uc_dc: false,
      uc_tm: false,
      uc_sc: false,
      uc_no_export: false,
      exportManagement: exportManagement,
      gensetBackfeedProtection:
        gensetDetails?.gensetBackfeedProtectionStatus === "Y" ? true : false,
      gensetLSIEnable: gensetLSIEnable,
      loadShedding: loadShedding.loadShedding,
      loadSheddingActivatedGridTied: loadShedding.loadSheddingGridtiedStatus === "N" ? false : loadShedding.loadSheddingActivatedGridTied,
      utilityLSIEnable: utilityLSIEnable,
      gensetLoad: gensetLoad,
      maxExportPower: maxExportPower,
      maxLimitEnergyExportPower: Number(maxExportPower),
      maxLimitEnergyImportPower: Number(limitImportExport?.maxLimitEnergyImportPower),
      bessImport: limitImportExport?.bessImport,
       bessExport: limitImportExport?.bessExport,
        pvExport: limitImportExport?.pvExport,
      importType: limitImportExport?.importType,
      exportType: limitImportExport?.exportType,
      importStartHysteresis: importStartHysteresis,
      importStopHysteresis: Number(importStopHysteresis),
      // peakStartImportHysteresis:
      //   peakImportHysteresis?.startHysteresisPercent === ""
      //     ? "0"
      //     : peakImportHysteresis?.startHysteresisPercent,
      // peakStopImportHysteresis:
      //   peakImportHysteresis?.stopHysteresisPercent === ""
      //     ? "0"
      //     : peakImportHysteresis?.stopHysteresisPercent,
      limitExport: limitExport,
      limitImport: limitImport,

      meteringPriority: derPriority,
      resetLoads: false,
      pvCurtailmentExport: pvCurtailmentExport,
      lossOfComm: lossOfComm,
      portableGensetMethod: isPortableGensetSelection,
      portableGenset: isPortableGenset,
      batteryBufferingExport: batteryDetails?.batteryBufferingExport,
      BESS: batteryDetails?.batteryBufferingStatus === true ? newBESS : null,
      Genset: newGenset,
      reconnectionTimer: reconnectionTimers?.reconnectionTimer,
      reconnection2Timer: reconnectionTimers?.reconnection2Timer,
      loadPercentage:
        parseInt(gensetLoad) > 0
          ? (
            (parseFloat(gensetLoad) / parseFloat(maxGensetLoad)) *
            100
          ).toFixed(2)
          : 0.0,
      resources: resources,
      demandCharge: JSON.stringify(demandChargeData),
      tariffDynamicConfiguration:
        newTariffDynamicConfiguration === null
          ? null
          : JSON.stringify(newTariffDynamicConfiguration),
      sellTariff: sellTariff,
      deltaSellTariff: deltaSellTariff,
      programPage: false,
      bessHibernatingActivated: BESSHibernateEnabled === "Y" ? true : false,
      alarm: {
        alarmType: gridSettings?.remoteMonitoringControl
          ? selectedAlaram
          : "NO_ALARM",
        amsService: amsService,
        emails:
          selectedAlaram === "NO_ALARM" || !gridSettings?.remoteMonitoringControl
            ? []
            : emailUsers,
      },
    };
    if(["DaaS ANSI", "MGaaS ANSI", "DaaS ETO"].includes( projectKind?.projectTypeValue || projectTypeValue)){
      programDataJson.maxExportPower = limitExport === true?maxExportPower:0;
      programDataJson.maxLimitEnergyExportPower=limitExport === true? Number(maxExportPower):0;
      programDataJson.maxLimitEnergyImportPower = limitImport === true? Number(limitImportExport?.maxLimitEnergyImportPower):0;
    }
    if(projectKind?.projectTypeValue !== "NMGaaS ETO" || projectTypeValue !== "NMGaaS ETO" || projectTypeData !== "NMGaaS ETO"){
        programDataJson.peakStartImportHysteresis = peakImportHysteresis?.startHysteresisPercent === "" ? "0": peakImportHysteresis?.startHysteresisPercent
        programDataJson.peakStopImportHysteresis = peakImportHysteresis?.stopHysteresisPercent === ""? "0": peakImportHysteresis?.stopHysteresisPercent
      }
    if (demandChargeUseCaseSelection === "DCMP" && dcthreshold) {
        let dcthresholdJson = { ...dcthreshold };
        if (dcthresholdJson.type === "FIXED") {
          dcthresholdJson.customValues = null;
        } else {
          dcthresholdJson.fixedValues = null;
        }
        programDataJson.dcThreshold = JSON.stringify(dcthresholdJson);
      }
      if ( billingPeriod) {
        let billingPeriodJson = { ...billingPeriod };
        if (billingPeriodJson.billingType === "CUSTOM") {
          billingPeriodJson.fixDay = null;
        } else {
          billingPeriodJson.customDays = null;
        }
        programDataJson.billingPeriod = siteType ==="OFF_GRID"?null: JSON.stringify(billingPeriodJson);
      }
    if (
      loadList?.gridTiedNotAllowIslandingList?.length > 0 ||
      loadList?.gridTiedAllowIslandingList?.length > 0
    ) {
      programDataJson.gridTiedLoadsSheddable = Number(gridTiedLoadsSheddable);
    } else {
      programDataJson.gridTiedLoadsSheddable = 0;
    }
    if (!derPriority) {
      delete programDataJson.meteringPriority;
    }
    // if (limitImport === false || limitImport === null) {
    //   programDataJson.maxLimitEnergyImportPower = 0;
    // }
    // if (limitExport === false || limitExport === null) {
    //   programDataJson.maxLimitEnergyExportPower = 0;
    // }
    if (
      gridSettings?.demandCharge === false &&
      gridSettings?.tariffManagement === false
    ) {
      programDataJson.tariffDynamicConfiguration = null;
      programDataJson.sellTariff = null;
      programDataJson.deltaSellTariff = null;
    }
    if (sellTariff === "at0") {
      programDataJson.deltaSellTariff = null;
    }
    if (
      gridSettings?.demandCharge === true ||
      gridSettings?.tariffManagement === true
    ) {
      validateDemandCharge(demandChargeOutput);
      programDataJson.demandCharge = validateDemandCharge(demandChargeOutput)
        ? JSON.stringify(demandChargeOutput)
        : null;
      // programDataJson.demandCharge = JSON.stringify(demandChargeOutput)
    } else {
      programDataJson.demandCharge = null;
    }

    if (batteryDetails?.batteryBufferingStatus === true) {
      let BESSChargingNew = Object.assign({}, BESSCharging);

      // BESSChargingNew.BESS_charging_limitation_enabled =
      //   BESSChargingEnabled === "Y" ? true : false;
      // BESSChargingNew.BESS_PV_limitation_enable =
      //   BESSChargingEnabled === "Y" ? true : false;
      // BESSChargingNew.BESS_PV_disconnection =
      //   BESSChargingEnabled === "Y" ? true : false;
      // setBESSCharging(BESSChargingNew);
      programDataJson.bessChargingLimitation = JSON.stringify(BESSChargingNew);
    } else {
      programDataJson.bessChargingLimitation = null;
    }
     if (eVceData?.isElectricalVehicleEnergyManagement) {
        let copyEvceData = { ...eVceData };
        copyEvceData.midPeakPowerLimit = evMaxAllowedPower === 0? "" : copyEvceData?.midPeakPowerLimit;
        copyEvceData.onPeakPowerLimit = evMaxAllowedPower === 0? "" : copyEvceData?.onPeakPowerLimit;
        programDataJson.electricalVehicleEnergyMgmtJson = JSON.stringify(copyEvceData);
      }
    sessionStorage.setItem("draftSave", JSON.stringify(programDataJson));
    if (onDemand === true) {
      saveDraftProgramOnDemand(programDataJson);
    }
  };

  const saveDraftProgramOnDemand = (data) => {
    if (UserScope.access.saveProgram === true) {
      setLoading(true);
      apiSession
        .saveDraftProgram(data)
        .then(() => {
          callSnackbar("success", "Saved successfully");
          setLoading(false);
          sessionStorage.setItem("programDataModified", false);
        })
        .catch(() => {
          setLoading(false);
          callSnackbar("error", "Error in saving data");
        });
    }
  };

  const reset = () => {
    getProgramData(projectId).finally(() => {
      // CalendarTariff listens to lastSubmit; bump this to force reset/apply fetched data.
      setRefresh((prev) => prev + 1);
      // Trigger nested components (e.g. Metering Priority) that keep local state.
      setOuterResetTrigger((prev) => prev + 1);
    });
  };

  //* snackbar

  const callSnackbar = useCallback((type, message) => {
    try {
      setSnackBar({ type, message });
      snackBarRef.current.open = true;
    } catch (error) {
      console.log("error in snack bar");
    }
  }, []);

  const setAlertMessage = (title, isRoute, routePath, message) => {
    setAlert({
      title,
      isRoute,
      routePath,
      message,
      alertPopUpStatus: true,
    });
  };

  const closeAlertMessage = useCallback(() => {
    setAlert({
      message: "",
      alertPopUpStatus: false,
      title: "",
      isRoute: false,
      routePath: "",
    });
    if (alert.isRoute) {
      let { history } = props;
      history.push({
        pathname: `/${alert.routePath}`,
      });
    }
  }, [alert, props]);

  const handlePortableGenset = () => {
    setIsPortableGenset((prev) => !prev);
    setConfiguredStatus((prev) => {
      return {
        ...prev,
        lsConfiguredStatus: 1
      }
    })
  };
  const portableGensetSelection = (e) => {
    setIsPortableGensetSelection(e.target.value);
  };

  const exportManagementBessMode = (e) => {
    setIsBessOperatingMode(e.target.value);
    configuredStatusModified("bessOperatingModeStatus");
    // switch (e.target.value) {
    //   case "UNRESTRICTED":
    //     setLimitImportExport((prev) => ({
    //       ...prev,
    //       bessImport: true,
    //       bessExport: true,
    //     }));
    //     break;
    //   case "EXPORT_ONLY":
    //     setLimitImportExport((prev) => ({
    //         ...prev,
    //       bessImport: false,
    //       bessExport: true,
    //       pvExport: true,
    //       }));
    //    break;
    //   case "IMPORT_ONLY":
    //   setLimitImportExport((prev) => ({
    //       ...prev,
    //       bessImport: true,
    //       bessExport: false, 
    //       pvExport:true,
    //       })); 
    //     break;
    //   case "NO_EXCHANGE":
    //     setLimitImportExport((prev) => ({
    //       ...prev,
    //        bessImport: false,
    //       bessExport: false, 
    //        pvExport:true,
    //     }));
    //     break;
    //   }
  };
  const handleDynamicTariffConfiguration = (e) => {
    const copyTariffDynamicConfiguration = tariffDynamicConfiguration;
    const { name, value } = e.target;
    let scale = /^$|^\d+$/;
    let deltalet = /^$|^[-+]?\d*\.?\d*$/;
    switch (name) {
      case "scale":
        if (scale.test(Number(e.target.value))) {
          setTariffDynamicConfiguration((prev) => ({
            ...prev,
            spotPriceTariff: {
              ...prev.spotPriceTariff,
              [name]: value,
            },
          }));
          configuredStatusModified("dynamicConfiguredStatus");
        }
        break;
      case "region":
        setTariffDynamicConfiguration((prev) => ({
          ...prev,
          spotPriceTariff: {
            ...prev.spotPriceTariff,
            [name]: value,
          },
        }));
        configuredStatusModified("dynamicConfiguredStatus");
        break;
      case "country":
        setTariffDynamicConfiguration((prev) => ({
          ...prev,
          dynamicHourTariff: {
            ...prev.dynamicHourTariff,
            platformDayAhead: value,
          },
        }));
        break;
      case "area":
        {
        const epexResolutionList =
          defaultDynamicTariff?.tariffTypeList?.["24-Hour Day Ahead Tariff"]?.[1]?.[
            "EPEX"
          ]?.[value] || [];
        setTariffDynamicConfiguration((prev) => ({
          ...prev,
          dynamicHourTariff: {
            ...prev.dynamicHourTariff,
            platformDayAhead: value,
            resolution: epexResolutionList?.[0] || "",
          },
        }));
        }
        break;
      case "resolution":
         setTariffDynamicConfiguration((prev) => ({
          ...prev,
          dynamicHourTariff: {
            ...prev.dynamicHourTariff,
            resolution: value,
          },
        }));
        break;
      case "platform":
        configuredStatusModified("dynamicConfiguredStatus");

        if (value === "omie") {
          setTariffDynamicConfiguration((prev) => ({
            ...prev,
            dynamicHourTariff: {
              ...prev.dynamicHourTariff,
              platformType: value,
              platformDayAhead: null,
              resolution: null,
            },
          }));
        }
        if (value === "epex") {
          const epexAreaMap =
            defaultDynamicTariff?.tariffTypeList?.["24-Hour Day Ahead Tariff"]?.[1]?.[
              "EPEX"
            ] || {};
          const firstEpexArea = Object.keys(epexAreaMap)?.[0] || "";
          const firstEpexResolution = epexAreaMap?.[firstEpexArea]?.[0] || "";

          setTariffDynamicConfiguration((prev) => ({
            ...prev,
            dynamicHourTariff: {
              ...prev.dynamicHourTariff,
              platformType: value,
              platformDayAhead: firstEpexArea,
              resolution: firstEpexResolution,
            },
          }));
        }

        break;
      case "platformDayAhead":
        configuredStatusModified("dynamicConfiguredStatus");
        setTariffDynamicConfiguration((prev) => ({
          ...copyTariffDynamicConfiguration,
          dynamicHourTariff: {
            ...prev.dynamicHourTariff,
            [name]: value,
          },
        }));
        break;
      case "tariffType":
        if (value === "null") {
          setTariffDynamicConfiguration(null);
        } else if (value === "spotPrice") {
          setTariffDynamicConfiguration((prev) => ({
            ...prev,
            [name]: value,
            spotPriceTariff: {
              platformSpotPrice: "aemo",
              scale: 1000,
              region: "vic1",
            },
          }));
        } else {
          setTariffDynamicConfiguration((prev) => ({
            ...prev,
            [name]: value,
            dynamicHourTariff: {
              platformDayAhead: "",
            },
          }));
        }

        configuredStatusModified("dynamicConfiguredStatus");
        break;
      case "sellTariff":
        configuredStatusModified("sellTariffConfiguration");
        setSellTariff(value);
        break;
      case "deltaSellTariff":
        if (deltalet.test(value)) {
          configuredStatusModified("sellTariffConfiguration");
          setDeltaSellTariff(value);
        }

        break;
      default:
        setTariffDynamicConfiguration((prev) => ({ ...prev, [name]: value }));
        break;
    }
  };
   const formatIp = (value) => {
    const digits = value.replace(/\D/g, "");
    const segments = [];
    if (digits.length > 0) segments.push(digits.substring(0, 3));
    if (digits.length > 3) segments.push(digits.substring(3, 6));
    if (digits.length > 6) segments.push(digits.substring(6, 9));
    if (digits.length > 9) segments.push(digits.substring(9, 12));
    return segments.join(".");
  };
  const handleEVCE = (e) => {
    const { name, checked, value } = e.target;
    if (name === "electricalVehicleEnergyManagement") {
      setEvceData((prev) => {
        return {
          ...prev,
          isElectricalVehicleEnergyManagement: checked,
        };
      });
    } else if (name === "onPeakPowerLimit") {
      setEvceData((prev) => {
        return {
          ...prev,
          onPeakPowerLimit: value,
          midPeakPowerLimit: value,
         highTariffCurtailment: value === ""?0:((evMaxAllowedPower - value) / evMaxAllowedPower) * 100,
        };
      });
    } else if (name === "noOfZones") {
      if (/^(?:[1-9]?[0-9])$/.test(value) || value === "") {
        setEvceData((prev) => {
          return {
            ...prev,
            [name]: value,
          };
        });
      }
    }else if(name === "ipAddressTMH"){
      const formatted = formatIp(value);
       setEvceData((prev) => {
        return {
          ...prev,
          ipAddress: formatted,
        };
      });
    }else if(name === "evMaxAllowedPowerDM"){
      const formatted = value === "" ? "" : Number(value);
      setEvceData((prev) => {
        return {
          ...prev,
          evMaxAllowedPowerDM: formatted,
        };
      });
    }
     else {
      setEvceData((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
    }
  };
  const handleLimitExportImportOptimization = (e) => {
    const { name, checked } = e.target;
    configuredStatusModified("emConfiguredStatus");
    switch (name) {
      case "limitEnergyImport":
        setLimitImport(checked);
         setLimitImportExport((prev) => {
          return {
            ...prev,
            bessImport: checked,
          };
        });
        if (siteType === embLabels.ISLANDABLE && projectTypeData === "MGaaS ANSI" || projectTypeData === "MGaaS IEC" || projectTypeData === "MGaaS ETO") {
          loadSheddingReset();
          setLoadShedding((prevState) => ({
            ...prevState,
            loadSheddingActivatedGridTied: checked,
            loadSheddingGridtiedStatus: "N",
          }));
        } else {
          loadSheddingReset();
          setLoadShedding((prevState) => ({
            ...prevState,
            loadShedding: false,
            loadSheddingActivatedGridTied: checked,
            loadSheddingGridtiedStatus: "N",
          }));
        }
        break;
      case "limitEnergyExport":
        setLimitExport(checked);
        setLimitImportExport((prev) => {
          return {
            ...prev,
            bessExport:["EXPORT_ONLY","UNRESTRICTED"].includes(isBessOperatingMode)?true: false,
            // pvExport: false
          };
        });
        break;
      default:
        break;
    }
  };
  const importManagementhandler = (e) => {
    const { value } = e.target;
    const apiImportPowerLimit = Number(apiMaxLimitEnergyImportPower.current);
    const utilityImportPowerLimit = Number(derMaxPowerMap?.Utility);
    const unrestrictedImportDefault =
      Number.isFinite(utilityImportPowerLimit) && utilityImportPowerLimit > 0
        ? utilityImportPowerLimit
        : Number.isFinite(apiImportPowerLimit)
        ? apiImportPowerLimit
        : 0;
    configuredStatusModified("importManagementStatus");
    setLimitImportExport((prev) => {
      return {
        ...prev,
        importType: value,
         maxLimitEnergyImportPower: value === "Unrestricted Import"
          ? (derMaxPowerMap?.Utility ?? prev.maxLimitEnergyImportPower)
          : prev.maxLimitEnergyImportPower,
      };
    });
  };
  const exportManagementhandler = (e) => {
     const { value } = e.target;
    const apiExportPowerLimit = apiMaxLimitEnergyExportPower.current;
    configuredStatusModified("exportManagementStatus1");
    setLimitImportExport((prev) => {
      return {
        ...prev,
        exportType: value,
         maxLimitEnergyExportPower: value === "Unrestricted Export"
          ? derMaxPowerMap?.Utility ??apiExportPowerLimit
          : prev.maxLimitEnergyExportPower,
      };
    });
  };
  const handleBillingCycle = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "billingCycleStartDate":
        if (billingPeriod.billingType === "FIRST") {
          setBillingPeriod((prev) => {
            return {
              ...prev,
              customDays: null,
              fixDay: 1,
            };
          });
        } else if (billingPeriod.billingType === "FIXED") {
          if (!(/^(?:\d+)?$/.test(value))) return;
          setBillingPeriod((prev) => {
            return {
              ...prev,
              customDays: null,
              fixDay: value,
            };
          });
        } else {
          setBillingPeriod((prev) => {
            return {
              ...prev,
              billingType: null,
            };
          });
        }

        break;
      case "billingType":
        if (["FIRST"].includes(value)) {
          setBillingPeriod((prev) => {
            return {
              ...prev,
              customDays: null,
              billingType: value,
              fixDay: 1
            };
          });
        } else {
          setBillingPeriod((prev) => {
            return {
              ...prev,
              billingType: value,
            };
          });
        }
        break;
      default:
        setBillingPeriod((prev) => {
          return {
            ...prev,
            [name]: value,
          };
        });
        break;
    }
  };
  const handleDcthreshold = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "type":
        setDcthreshold((prev) => {
          if (value === "FIXED") {
            return {
              ...prev,
              [name]: value,
              customValues: null,
            };
          } else {
            return {
              ...prev,
              [name]: value,
              fixedValues: null,
            };
          }
        });
        break;
      case "valueType":
        setDcthreshold((prev) => {
          return {
            ...prev,
            [name]: value,
            ["fixedValues"]: {
              ["peakPreset"]: "",
              ["billingPeriodPreset"]: "",
            },
            customValues: generateDefaultData(),
          };
        });
        break;
      case "demandLimit1":
        if (dcthreshold.valueType !== "PERCENTAGE" && !(/^(?:\d+)?$/.test(value))) return;
        setDcthreshold((prev) => {
          let demandValue;
          if (prev.valueType === "VALUE" && parseInt(value) <= 999) {
            demandValue = value;
          } else {

            if (value === "" || (/^(^$|100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?)|(\d{1,2}\.))$/.test(value) && parseFloat(value) <= 100)) {
              demandValue = value;
            } else {
              demandValue = prev.fixedValues.peakPreset;
            }
          }
          return {
            ...prev,
            ["fixedValues"]: {
              ...prev.fixedValues,
              ["peakPreset"]: demandValue,
            },
          };
        });
        break;
      case "demandLimit2":
        if (dcthreshold.valueType !== "PERCENTAGE" && !(/^(?:\d+)?$/.test(value))) return;
        setDcthreshold((prev) => {
          let demandValue;
          if (prev.valueType === "VALUE" && parseInt(value) <= 999) {
            demandValue = value;
          } else {
            if (value === "" || /^(100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?)|(\d{1,2}\.))$/.test(value) && parseFloat(value) <= 100) {
              demandValue = value;
            } else {
              demandValue = prev.fixedValues.billingPeriodPreset;
            }
          }
          return {
            ...prev,
            ["fixedValues"]: {
              ...prev.fixedValues,
              ["billingPeriodPreset"]: demandValue,
            },
          };
        });
        break;
      default:
        break;
    }
    configuredStatusModified("dcThresholdStatus");
  };
  const handleDcThresholdCustomMonth = (customMonthData) => {
    setDcthreshold((prev) => {
      return {
        ...prev,
        customValues: customMonthData,
      };
    });
  };
  return (
    <div className="container-fluid container-margin">
      <se-loading loading={loading} full-page="true"></se-loading>

      <se-container option="centered">
        <div className="row">
          {(projectStatusData?.projectStatus === "COMPLETED" ||
            projectStatusData?.projectStatus === "COMPLETED_AND_SEND") && (
              <div className="col-sm-12 text-center  mt-1 ">
                <span className="se-error-message-note text-center">
                  {`Change the project state to in-progress to update the project`}
                </span>
              </div>
            )}
          {UserScope.access.saveProgram &&( siteCreated  && projectTypeData !=="NMGaaS ETO")&& (
            <div className="col-sm-12 text-center mt-1 ">
              <span className="se-error-message-note text-center">
                {`Site already created for the project, no more modifications allowed`}
              </span>
            </div>
          )}
        </div>
        {UserScope.access.saveProgram !== true && (
          <div className="col-sm-12 text-center mt-1">
            <span className="se-error-message-note text-center">
              {"Information: " +
                UserScope.role +
                " is not authorized to perform action on this page"}
            </span>
          </div>
        )}
        <div
          className={`container mb-2 mt-2 ${(siteCreated && projectTypeData !=="NMGaaS ETO")||
              projectStatusData?.projectStatus === "COMPLETED" ||
              projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
              ? "se-block-disabled"
              : !UserScope.access.saveProgram
                ? "se-block-disabled"
                : ""
            }`}
        ></div>

        <div className={`container mb-2 mt-2 custom-container `}>
          <DesignProgramProvider
            value={{
              validResultFunc,
              validateProgram,
              gridSettings,
              isMotorizedOrContactor,
              configuredStatus,
              demandChargeData,
              demandChargeOutput,
              siteType,
              maxExportPower,
              importStartHysteresis,
              importStopHysteresis,
                maxLimitEnergyExportPower,
              maxLimitEnergyImportPower,
              limitImportExport,
              peakImportHysteresis,
              derMaxPowerMap,
              batteryDetails,
              pvCurtailmentExport,
              utilityLSIEnable,
              loadsDisplay,
              loadShedding,
              gridTiedLoadsSheddable,
              loads,
              loadList,
              reconnectionTimers,
              defaultsMinMax,
              values,
              domain,
              gridDetails,
              gensetDetails,
              gensetLoad,
              maxGensetLoad,
              pvCurtailment,
              lossOfComm,
              lossOfCommEMA,
              gensetLSIEnable,
              BESSChargingEnabled,
              BESSCharging,
              BESSHibernateEnabled,
              BESS,
              powerReservePercentageBESS,
              genset,
              powerReservePercentageGenset,
              templateSelected,
              architectureType,
              clientType,
              autogridOptimization,
              optimizationServer,
              defaultDynamicTariff,
              tariffDynamicConfiguration,
              sellTariff,
              deltaSellTariff,
              handleDynamicTariffConfiguration,
              demandChargeDataCallback,
              exportManagementChange,
              configuredStatusModified,
              handleChange,
              handleCheckBoxChange,
              handlepPVOpeningPopup,
              isBessOperatingMode,
              exportManagementBessMode,
              loadSheddingChangeHandler,
              onDrag,
              onDrop,
              onDragFrom,
              onDragOver,
              handleRadioButtonChange,
              handleGensetOptimizationConfirm,
              openBessChargingpopup,
              openBessHibernatepopup,
              onUpdate,
              onChange,
              handleChangeBESS,
              handleChangePowerReservePercentage,
              handleChangeGenset,
              enableTemplatePopUp,
              autogridDetailsHandler,
              handlePortableGenset,
              isPortableGenset,
              portableGensetSelection,
              isPortableGensetSelection,
              refresh,
              outerResetTrigger,
              siteCreated,
              projectStatusData,
              UserScope,
              handleLimitExportImportOptimization,
              limitExport,
              limitImport,
              currency,
              derPriority,
              setDerPriority,
              demandChargeUseCaseSelection,
              eVceData,
              isTMHSelected,

              handleEVCE,
              handleBillingCycle,
              billingPeriod,
              handleDcthreshold,
              dcthreshold,
              handleDcThresholdCustomMonth,
              dcthresholdCustomMonthErrors,
              updateUtilityDates,
              generateDefaultData,
              evMaxAllowedPower,
              projectTypeData,
               exportManagementhandler, 
              importManagementhandler
            }}
          >
            {(gridSettings?.remoteMonitoringControl && projectTypeData !=="NMGaaS ETO")&& (
              <OperationUser
                siteCreated={siteCreated}
                projectStatusData={projectStatusData}
                projectTypeData ={projectTypeData}
                siteGroup={siteGroup}
                UserScope={UserScope}
                siteUsers={siteUsers}
                handleChangeSiteGroup={handleChangeSiteGroup}
                addUserSite={addUserSite}
                removeSiteUserConfirmationPrompt={
                  removeSiteUserConfirmationPrompt
                }
              />
            )}

            { projectTypeData !== "NMGaaS ETO" && 
            siteType !== embLabels.GRID_CONNECTED_GSX &&
              gridSettings?.remoteMonitoringControl &&
              !(
                clientType === embLabels.GREENSTRUXURE_PROJECT &&
                siteType === embLabels.ISLANDABLE_GSX &&
                architectureType === embLabels.PV_GENSET_ATS &&
                gridSettings?.mode == "FUEL_SAVER"
              ) && (
                <Alarming
                  siteCreated={siteCreated}
                  projectTypeData={projectTypeData}
                  projectStatusData={projectStatusData}
                  siteType={siteType}
                  architectureType={architectureType}
                  selectedAlaram={selectedAlaram}
                  selectedAlaram2={selectedAlaram2}
                  amsService={amsService}
                  UserScope={UserScope}
                  emailUsers={emailUsers}
                  alaramChangeHanlder={alaramChangeHanlder}
                  addEmailToAlaram={addEmailToAlaram}
                  removeUserFromAlarmStatus={removeUserFromAlarmStatus}
                 
                />
              )}

            {gridSettings?.remoteMonitoringControl &&
              siteType &&
              siteType !== embLabels.GENSET_PVBESS_A2E && (
                <OptimizationEngine />
              )}

            <div className="row mt-1 mb-2">
              <div className="col-md-12"></div>
            </div>

            {siteType && siteType !== embLabels.GENSET_PVBESS_A2E && (
              <OnGridOptimization />
            )}

            <div className="row mt-1 mb-2">
              <div className="col-md-12"></div>
            </div>

            {siteType && <OffGridManagement />}

            <div className="row mt-1 mb-2">
              <div className="col-md-12"></div>
            </div>

            {/* {siteType &&
              siteType !== embLabels.GENSET_PVBESS_A2E &&
              siteType !== embLabels.GRID_CONNECTED_GSX &&
              siteType !== embLabels.ISLANDABLE_GSX &&
              // siteType !== embLabels.ISLANDABLE &&
              gridSettings.mode == "FUEL_SAVER" && (
                <DisabledUseCase
                 gridSettings={gridSettings}
                 UserScope = {UserScope}
                siteCreated ={siteCreated}
                projectStatusData = {projectStatusData}
                 />
              )} */}

            {siteType && (
              <div
                className={`row mt-2 ${(siteCreated && projectTypeValue !== "NMGaaS ETO")||
                    projectStatusData?.projectStatus === "COMPLETED" ||
                    projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
                    ? "se-block-disabled"
                    : !UserScope.access.saveProgram
                      ? "se-block-disabled"
                      : ""
                  }`}
              >
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12  text-right">
                  {(gridSettings.demandCharge ||
                    gridSettings.tariffManagement) && ! (projectKind?.projectTypeValue === "NMGaaS ETO" || projectTypeValue === "NMGaaS ETO" || projectTypeData === "NMGaaS ETO") &&(
                      <se-button
                        option="flat"
                        color="primary"
                        disabled={false}
                        onClick={saveNewTemplate}
                      >
                        Save Tariff Template
                      </se-button>
                    )}
                  <se-button
                    option="flat"
                    color="primary"
                    disabled={
                      UserScope.access.saveProgram === true ? false : true
                    }
                    onClick={() => saveDraftGenerateProgram(true)}
                  >
                    Save as Draft
                  </se-button>
                  <se-button
                    option="flat"
                    color="primary"
                    disabled={
                      UserScope.access.saveProgram === true ? false : true
                    }
                    // onClick={(gridSettings.demandCharge || gridSettings.tariffManagement) ?  validResultFuncProgram : validateProgram}
                    onClick={validResultFuncProgram}
                  >
                    Validate Usecase
                  </se-button>
                  <se-button option="outline" onClick={reset}>
                    Reset
                  </se-button>
                </div>
              </div>
            )}
          </DesignProgramProvider>
        </div>

        {popupStatus.addUserPopUpStatus && (
          <SiteAddUser
            emaUserRoles={emaRoles}
            popUpstatus={popupStatus.addUserPopUpStatus}
            addUserSiteList={addUserToSiteList}
            closeAddUser={closeAddUser}
            message="Invite User(s) to the site"
          />
        )}

        {popupStatus.inviteUserToAlaramStatus && (
          <SiteAddUser
            popUpstatus={popupStatus.inviteUserToAlaramStatus}
            addUserSiteList={inviteUserToAlaramList}
            closeAddUser={closeInviteEmailToAlaram}
            message="Add User(s) to the Alarm"
          />
        )}

        <SelectTemplate
          isOpen={popupStatus.templatePopUpStatus}
          templates={templates}
          disableTemplatePopUp={disableTemplatePopUp}
          selectTemplate={selectTemplate}
           callSnackbar = {callSnackbar}
          projectTypeValue = {projectKind?.projectTypeValue === "NMGaaS ETO" || projectTypeValue === "NMGaaS ETO" || projectTypeData === "NMGaaS ETO"}
        />

        <Snackbar snackBar={snackBar} ref={snackBarRef} />
        <AlertIcon alert={alert} onClose={closeAlertMessage} />

        <se-dialog
          id="dialog-complex-delete-confirm"
          open={popupStatus.deleteSiteUserConfirmPopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Do you confirm to delete invited site user ?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={removeSiteUserConfirm}>Yes</se-button>
            <se-button onClick={closeDeleteSiteUserPopUp}>No</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-delete-confirm"
          open={popupStatus.deleteUserFromAlarmStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Do you confirm to delete added user ?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={removeEmailFromAlaram}>Yes</se-button>
            <se-button onClick={closeDeleteInviteUserpopup}>No</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.loadSheddingConfirmPopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Please ensure genset and/or BESS can feed inrush currents and
              continuous loads.
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelLoadSheddingConfirm}>Cancel</se-button>
            <se-button onClick={acceptLoadSheddingConfirm}>OK</se-button>
          </se-dialog-footer>
        </se-dialog>


        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.loadSheddingIslandConfirmPopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Please ensure genset and/or BESS can feed inrush currents and
              continuous loads.
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelLoadSheddingIslandConfirm}>Cancel</se-button>
            <se-button onClick={acceptLoadSheddingGriedTiedConfirm}>OK</se-button>
          </se-dialog-footer>
        </se-dialog>
        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.loadSheddingConfirmTruePopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Do you want to activate load shedding in island mode?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelLoadSheddingTrueConfirm}>No</se-button>
            <se-button onClick={acceptLoadSheddingTrueConfirm}>Yes</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.loadSheddingIslandConfirmTruePopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Do you want to activate load shedding to limit import from utility?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelLoadSheddingGridTiedTrueConfirm}>No</se-button>
            <se-button onClick={acceptLoadSheddingGridTiedTrueConfirm}>Yes</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.gensetOptimisationConfirmPopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Do you want to activate genset optimization and backfeed
              protection?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelGensetOptimisation}>No</se-button>
            <se-button onClick={confirmGensetOptimisation}>Yes</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.bessChargingConfirmPopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              Do you want to activate BESS charging limitation?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelBessCharging}>No</se-button>
            <se-button onClick={confirmBessCharging}>Yes</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.besshibernateConfirmPopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              If hibernating is activated, BESS will stop when SoC becomes lower
              than SoC Min. Manual action is needed to restart BESS. Do you want
              to activate BESS hibernating ?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelBessHibernate}>No</se-button>
            <se-button onClick={confirmBessHibernate}>Yes</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.utilityPvOpeningConfirmpopUpSattus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              This option requires a motorized PV breaker, Do you confirm ?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelUtilityPvopenPopUp}>No</se-button>
            <se-button onClick={confirmUtilityPVOpen}>Yes</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-additionalUserAlert"
          open={additionalUserAlert}
          can-backdrop="false"
        >
          <se-dialog-header>Info</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              If you want to allow more users to be invited, please update the
              additional users section on the information page.
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={() => setAdditionalUserAlert()}>Ok</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-loadshedding-confirm"
          open={popupStatus.gensetPvOpeningConfirmpopUpSattus}
          can-backdrop="false"
        >
          <se-dialog-header>Confirmation</se-dialog-header>
          <se-dialog-content>
            <span className="se-font-14px">
              This option requires a motorized PV breaker, Do you confirm ?
            </span>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={cancelGensetPvopenPopUp}>No</se-button>
            <se-button onClick={confirmGensetPVOpen}>Yes</se-button>
          </se-dialog-footer>
        </se-dialog>

        <se-dialog
          id="dialog-complex-delete-confirm"
          open={popupStatus.newTemplateConfirmPopUpStatus}
          can-backdrop="false"
        >
          <se-dialog-header>
            Do you want to save this template?
          </se-dialog-header>
          <se-dialog-content>
            <div className="col-md-12">
              <div className="form-group row mb-0">
                <label
                  htmlFor="copyProjectName"
                  className="col-sm-9 col-form-label ml-3"
                >
                  Enter new template name
                </label>
              </div>
              <div className="form-group">
                <div className="col-sm-12">
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control form-control-sm"
                    id="copyProjectName"
                    name="copyProjectName"
                    maxLength="50"
                    value={newTemplateName}
                    onChange={handlenewTemplate}
                  />
                  <div
                    className="invalid-feedback-custom"
                    style={newTemplateName ? { display: "none" } : {}}
                  >
                    Template Name is mandatory
                  </div>
                  <div
                    className="invalid-feedback-custom"
                    style={
                      templates.filter(
                        (template) => template.title === newTemplateName
                      ).length
                        ? {}
                        : { display: "none" }
                    }
                  >
                    {newTemplateName} exsits, provide an unique name
                  </div>
                </div>
              </div>
            </div>
            <br></br>
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={closeNewTemplatePopUp}>Cancel</se-button>
            <se-button
              onClick={saveTemplate}
              disabled={
                [newTemplateName].includes("") ||
                Boolean(
                  templates.filter(
                    (template) => template.title === newTemplateName
                  ).length
                )
              }
            >
              OK
            </se-button>
          </se-dialog-footer>
        </se-dialog>
      </se-container>
    </div>
  );
};

export default DesignProgramHook;